import {
    Box, HStack, Input, Button, Table, Thead, Tbody, Tr, Th, Td, Text, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Flex, Image, Heading,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    VStack,
    Img, Accordion, AccordionItem, AccordionIcon, AccordionButton, AccordionPanel, Checkbox, Switch, useToast, Link, Select, IconButton, Stack, Tooltip,
    Divider, useMediaQuery, Spinner, FormControl, FormLabel, Wrap, WrapItem,
    Menu, MenuButton, MenuList, MenuItem, Grid, GridItem, Collapse, InputGroup, InputLeftAddon, Textarea, SimpleGrid, Badge
} from '@chakra-ui/react';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { FaEye, FaExternalLinkAlt, FaCopy, FaClipboardCheck, FaEllipsisV } from 'react-icons/fa';
import { bulkSetBloqueioProduto, getProdutos, getAnuncioML, putAnuncioML, setBloqueioProduto, getAnuncioMagalu, getAnuncioAmazon, getProdutoId, putProdutoTAGA, gerarOrcamento, getInfoAnuncioMLModal, getIntegracoes, recrearAnuncioML, createTicket, getLinkEcommerceProduto } from "../services/api";
import Preloader from "../components/Preloader";
import React, { useState, useRef, useEffect } from 'react';
import '../index.css';
import MultipleSelectFornecedor from "../components/MultipleSelectFornecedor";
import MultipleSelectMktplaces from "../components/MultipleSelectMktplaces";
import { FaSearch, FaTrash, FaPlus } from 'react-icons/fa';
import ReactDOMServer from 'react-dom/server';
import ScrollToTop from "../components/ScrollToTop";
import { useUsuarios, semBloqueados } from "../hooks/useUsuarios";
import $ from 'jquery';
import { checkPermission, checkPermissionUser } from "../services/permission";
import { useLocation } from 'react-router-dom';
import ProdutoImagem from "../components/ProdutoImagem";
import ModalListaProdutos from "../components/ModalListaProdutos";
import ProdutoDetalhesModal from "../components/ProdutoDetalhesModal";

const ROTULOS_CAUSA_BLOQUEIO = {
    furo_fornecedor: 'Furo de fornecedor',
    conferencia_divergente: 'Conferência de despacho',
    devolucao_divergente: 'Divergência na devolução',
    lista_massa: 'Bloqueio em massa',
    manual: 'Bloqueio manual',
    planilha: 'Planilha do fornecedor',
    script_pontual: 'Script pontual',
    fornecedor_descontinuado: 'Fornecedor descontinuado',
    sem_dimensao: 'Sem dimensão (aguardando medição)',
    desconhecido: 'Sem causa registrada',
};

// Motivos de bloqueio manual. Saíram do que a equipe ja escrevia a mao nas
// observacoes de conferencia e devolucao, para o historico ficar padronizado e
// dar para agrupar depois. "Outro" mantem o campo aberto para o que fugir.
const MOTIVOS_BLOQUEIO = [
    { valor: 'foto_divergente', rotulo: 'Foto não corresponde ao produto' },
    { valor: 'quantidade_kit', rotulo: 'Anúncio com quantidade ou kit errado' },
    { valor: 'incompleto', rotulo: 'Produto incompleto (falta peça)' },
    { valor: 'marca_divergente', rotulo: 'Marca diferente da anunciada' },
    { valor: 'codigo_incorreto', rotulo: 'Código do fabricante incorreto' },
    { valor: 'avariado', rotulo: 'Produto avariado ou de baixa qualidade' },
    { valor: 'cadastro_incorreto', rotulo: 'Cadastro incorreto (nome, descrição ou aplicação)' },
    { valor: 'dimensao_peso', rotulo: 'Dimensão ou peso impedem o envio' },
    { valor: 'fornecedor_sem_produto', rotulo: 'Fornecedor não tem mais o produto' },
    { valor: 'preco_incorreto', rotulo: 'Preço ou margem incorretos' },
    { valor: 'outro', rotulo: 'Outro (descrever)' },
];

const rotuloMotivo = (valor) => MOTIVOS_BLOQUEIO.find((m) => m.valor === valor)?.rotulo || '';

// Conteudo do tooltip do status: por que o produto foi bloqueado, sem precisar
// abrir a tela de Produtos Bloqueados.
const DetalheBloqueio = ({ produto }) => {
    const causa = ROTULOS_CAUSA_BLOQUEIO[produto?.bloqueio_causa] || 'Sem causa registrada';
    const quando = produto?.bloqueio_em
        ? new Date(produto.bloqueio_em).toLocaleDateString('pt-BR')
        : null;

    return (
        <Box fontSize="12px" lineHeight="1.5" maxW="280px">
            <Text fontWeight="bold">{causa}</Text>
            {produto?.bloqueio_motivo_texto && <Text mt={1}>{produto.bloqueio_motivo_texto}</Text>}
            {produto?.bloqueio_origem && <Text mt={1} opacity={0.8}>Origem: {produto.bloqueio_origem}</Text>}
            {quando && (
                <Text mt={1} opacity={0.8}>
                    Bloqueado em {quando}{produto?.bloqueio_user ? ` por ${produto.bloqueio_user}` : ''}
                </Text>
            )}
            {!produto?.bloqueio_causa && <Text mt={1} opacity={0.8}>Bloqueio anterior ao histórico.</Text>}
        </Box>
    );
};

const Produtos = () => {
    const [isMobile] = useMediaQuery("(max-width: 768px)");
    const location = useLocation();
    const toast = useToast()
    const [loading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [produtos, setProdutos] = useState([]);
    const [produtoView, setProdutoView] = useState([]);
    const [consulta, setConsulta] = useState('');
    const [buscaBool, setBuscaBool] = useState(false);
    const [selecaoMassa, setSelecaoMassa] = useState("");

    const [isConfirmBulkModalOpen, setIsConfirmBulkModalOpen] = useState(false);
    const [confirmBulkModalData, setConfirmBulkModalData] = useState({
        action: '', // 'bloquear' ou 'ativar'
        status: null, // 0 ou 1
        count: 0,
        produtoId: null // preenchido quando o bloqueio parte de um produto so
    });
    const [motivoBloqueio, setMotivoBloqueio] = useState('');
    const [motivoPadrao, setMotivoPadrao] = useState('');
    const [isBulkLoading, setIsBulkLoading] = useState(false);
    const closeConfirmBulkModal = () => {
        setIsConfirmBulkModalOpen(false);
        setConfirmBulkModalData({ action: '', status: null, count: 0, produtoId: null });
        setMotivoBloqueio('');
        setMotivoPadrao('');
        setSelecaoMassa("");
    };

    // O motivo gravado junta o item escolhido e o detalhe digitado, para o
    // historico ficar padronizado sem perder o que a pessoa quis explicar.
    const motivoFinal = () => {
        const detalhe = motivoBloqueio.trim();
        if (motivoPadrao === 'outro') return detalhe;
        const rotulo = rotuloMotivo(motivoPadrao);
        if (!rotulo) return detalhe;
        return detalhe ? `${rotulo} · ${detalhe}` : rotulo;
    };

    const motivoValido = () => (
        motivoPadrao === 'outro'
            ? motivoBloqueio.trim().length >= 3
            : !!motivoPadrao
    );

    const handleConfirmBulkAction = async () => {
        const { status, produtoId } = confirmBulkModalData;
        const motivo = motivoFinal();

        // Bloqueio de um produto so passa pelo mesmo modal, para o motivo ser
        // pedido nos dois caminhos.
        if (produtoId) {
            setIsBulkLoading(true);
            await handleSetBloqueioProduto(produtoId, status, motivo);
            setIsBulkLoading(false);
            closeConfirmBulkModal();
            return;
        }

        if (selectedProducts.length === 0) {
            toast({
                title: "Nenhum produto selecionado.",
                status: 'error',
                isClosable: true,
            });
            closeConfirmBulkModal();
            return;
        }

        setIsBulkLoading(true);
        setLoading(true);

        try {
            const response = await bulkSetBloqueioProduto(selectedProducts, status, motivo || null);

            if (response && response.success) {
                toast({
                    title: `Ação executada com sucesso!`,
                    description: `${response.sucessos} produtos atualizados. ${response.erros} falharam.`,
                    status: 'success',
                    isClosable: true,
                });

                setProdutos(prevProdutos =>
                    prevProdutos.map(p =>
                        selectedProducts.includes(p.produto_id)
                            ? { ...p, bloqueado: status }
                            : p
                    )
                );

                clearSelection();
            } else {
                throw new Error("Falha na resposta da API");
            }

        } catch (error) {
            toast({
                title: "Erro ao executar ação em massa.",
                description: "Ocorreu um erro. Tente novamente.",
                status: 'error',
                isClosable: true,
            });
        } finally {
            setIsBulkLoading(false);
            setLoading(false);
            closeConfirmBulkModal();
        }
    };

    const [isTicketModalOpen, setIsTicketModalOpen] = useState(false);
    const [selectedProductForTicket, setSelectedProductForTicket] = useState(null);
    const [ticketTemplate, setTicketTemplate] = useState('');
    const [isCreatingTicket, setIsCreatingTicket] = useState(false);

    const [integracoes, setIntegracoes] = useState({});
    const [loadingIntegracoes, setLoadingIntegracoes] = useState(false);

    const [isOpenFiltros, setIsOpenFiltros] = useState(false);
    const handleAccordionChange = () => {
        setIsOpenFiltros(!isOpenFiltros);
    };

    const [isOpenModalListaProdutos, setIsOpenModalListaProdutos] = useState(false);
    const closeModalListaProdutos = () => setIsOpenModalListaProdutos(false);
    const openModalListaProdutos = () => setIsOpenModalListaProdutos(true);

    const [produtoViewML, setProdutoViewML] = useState([]);
    const [isModalOpenML, setIsModalOpenML] = useState(false);
    const [precoML, setPrecoML] = useState("");
    const [premiumML, setPremiumML] = useState(null);
    const [estoqueML, setEstoqueML] = useState("");
    const [statusML, setStatusML] = useState("");
    const [isLoadingSkeletonML, setIsLoadingSkeletonML] = useState(true);
    const [isLoadingBtnML, setIsLoadingBtnML] = useState(false);
    const [contaML, setContaML] = useState("");

    const [produtoViewMagalu, setProdutoViewMagalu] = useState([]);
    const [isModalOpenMagalu, setIsModalOpenMagalu] = useState(false);
    const [precoMagalu, setPrecoMagalu] = useState("");
    const [estoqueMagalu, setEstoqueMagalu] = useState("");
    const [statusMagalu, setStatusMagalu] = useState("");
    const [isLoadingSkeletonMagalu, setIsLoadingSkeletonMagalu] = useState(true);
    const [isLoadingBtnMagalu, setIsLoadingBtnMagalu] = useState(false);

    const [produtoViewAmazon, setProdutoViewAmazon] = useState([]);
    const [isModalOpenAmazon, setIsModalOpenAmazon] = useState(false);
    const [precoAmazon, setPrecoAmazon] = useState("");
    const [estoqueAmazon, setEstoqueAmazon] = useState("");
    const [statusAmazon, setStatusAmazon] = useState("");
    const [isLoadingSkeletonAmazon, setIsLoadingSkeletonAmazon] = useState(true);
    const [isLoadingBtnAmazon, setIsLoadingBtnAmazon] = useState(false);

    const [produtoViewTAGA, setProdutoViewTAGA] = useState([]);
    const [isModalOpenTAGA, setIsModalOpenTAGA] = useState(false);
    const [precoTAGA, setPrecoTAGA] = useState("");
    const [estoqueTAGA, setEstoqueTAGA] = useState("");
    const [estoqueFisicoTAGA, setEstoqueFisicoTAGA] = useState("");
    const [codigoSimilaresTAGA, setCodigoSimilaresTAGA] = useState("");
    const [statusTAGA, setStatusTAGA] = useState("");
    const [isLoadingBtnTAGA, setIsLoadingBtnTAGA] = useState(false);
    const handleChangeEstoqueTAGA = (id, field, value) => {
        const newValue = field === 'quantidade' ? value : value;
        setEstoqueFisicoTAGA(prevEstoque => {
            return prevEstoque.map(item => {
                if (item.id === id) {
                    return {
                        ...item,
                        [field]: newValue,
                    };
                }
                return item;
            });
        });
    };
    const handleRemoveEstoqueTAGA = (id) => {
        setEstoqueFisicoTAGA(prevEstoque => prevEstoque.filter(item => item.id !== id));
    };
    const handleAddEstoqueTAGA = (id, produto_estoque_id) => {
        if (estoqueFisicoTAGA.length < 10) {
            const newItem = {
                id: Date.now(),
                produto_id: id,
                produto_estoque_id: produto_estoque_id,
                quantidade: "",
                localizacao: "",
            };
            setEstoqueFisicoTAGA(prevEstoque => [...prevEstoque, newItem]);
        } else {
            alert("Você atingiu o número máximo de registros (10).");
        }
    };

    const [pagina, setPagina] = useState(1);
    const [ultimaPagina, setUltimaPagina] = useState(1);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const [paginateFrom, setPaginateFrom] = useState(0);
    const [paginateTo, setPaginateTo] = useState(0);

    const [isModalConfirmarOpen, setIsModalConfirmarOpen] = useState(false);
    const [produtoParaRecrear, setProdutoParaRecrear] = useState(null);

    const [isModalRecrearOpen, setIsModalRecrearOpen] = useState(false);
    const [isLoadingRecrear, setIsLoadingRecrear] = useState(false);
    const [resultadoRecrear, setResultadoRecrear] = useState([]);

    const listaRef = useRef(null);
    const buttonRef = useRef(null);
    const [menuVisivel, setMenuVisivel] = useState(false);
    const toggleMenu = (produtoId) => {
        let value = produtoId;
        if (menuVisivel == produtoId) {
            value = false
        } else if (menuVisivel == false) {
            value = produtoId
        }
        setMenuVisivel(value);
    };

    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectedProductDetails, setSelectedProductDetails] = useState([]);
    const [nomeCliente, setNomeCliente] = useState('');
    const [documentoCliente, setDocumentoCliente] = useState('');
    const [enderecoCliente, setEnderecoCliente] = useState('');
    const [vendedor, setVendedor] = useState('');
    const [observacoes, setObservacoes] = useState('');
    const usuarios = useUsuarios();
    const vendedores = semBloqueados(usuarios).filter((u) => u.tipo == 2);
    const [telefoneCliente, setTelefoneCliente] = useState('');
    const [emailCliente, setEmailCliente] = useState('');
    const [valorFrete, setValorFrete] = useState('');

    const handleTelefoneChange = (e) => {
        let value = e.target.value;
        value = value.replace(/\D/g, "");
        value = value.replace(/^(\d{2})(\d)/g, "($1) $2");
        value = value.replace(/(\d{5})(\d)/, "$1-$2");
        value = value.replace(/(\d{4})-(\d)(\d{4})/, "$1$2-$3");
        setTelefoneCliente(value.slice(0, 15));
    };

    const handleFreteChange = (e) => {
        const rawValue = e.target.value;
        const digitsOnly = rawValue.replace(/\D/g, '');

        if (!digitsOnly) {
            setValorFrete('');
            return;
        }

        const valueInCents = parseInt(digitsOnly, 10);
        const formattedValue = new Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: 2,
        }).format(valueInCents / 100);

        setValorFrete(formattedValue);
    };

    const parseFormattedCurrency = (value) => {
        if (typeof value !== 'string' || value === '') {
            return 0;
        }
        const sanitizedValue = value.replace(/\./g, '').replace(',', '.');
        const parsed = parseFloat(sanitizedValue);
        return isNaN(parsed) ? 0 : parsed;
    };

    useEffect(() => {
        localStorage.setItem("selectedProducts", JSON.stringify(selectedProducts));
        localStorage.setItem("selectedProductDetails", JSON.stringify(selectedProductDetails));
    }, [selectedProducts, selectedProductDetails]);

    const isChecked = (id) => selectedProducts.includes(id);

    const selectableProducts = produtos.filter(
        (produto) => produto.quantidade > 0 && produto.bloqueado !== 1
    );

    const isAllSelected =
        selectableProducts.length > 0 &&
        selectableProducts.every((produto) => selectedProducts.includes(produto.produto_id));


    const handleSelectAll = () => {
        const selectableProducts = produtos.filter(
            (p) => p.quantidade > 0 && p.bloqueado !== 1
        );
        const selectableIds = selectableProducts.map(p => p.produto_id);
        if (isAllSelected) {
            setSelectedProducts((prevSelected) =>
                prevSelected.filter((id) => !selectableIds.includes(id))
            );
            setSelectedProductDetails((prevDetails) =>
                prevDetails.filter(
                    (produto) => !selectableIds.includes(produto.produto_id)
                )
            );
        } else {
            setSelectedProducts((prev) => [
                ...new Set([...prev, ...selectableIds]),
            ]);

            setSelectedProductDetails((prev) => {
                const newProductsToAdd = selectableProducts.filter(
                    p => !prev.some(detail => detail.produto_id === p.produto_id)
                );
                return [
                    ...prev,
                    ...newProductsToAdd.map((produto) => ({
                        ...produto,
                        quantidade_orcamento: 1,
                    })),
                ];
            });
        }
    };



    const handleCheckboxChange = (id, produto) => {
        setSelectedProducts((prev) => {
            if (prev.includes(id)) {
                return prev.filter((item) => item !== id);
            } else {
                return [...prev, id];
            }
        });


        setSelectedProductDetails((prev) => {
            if (prev.some((p) => p.produto_id === id)) {
                return prev.filter((p) => p.produto_id !== id);
            } else {
                const produtoComDetalhes = {
                    ...produto,
                    quantidade_orcamento: 1,
                };
                return [...prev, produtoComDetalhes];
            }
        });
    };

    const [desconto, setDesconto] = useState(0);
    const [descontoReais, setDescontoReais] = useState(0);
    const [subTotalOrcamento, setSubTotalOrcamento] = useState(0);
    const [totalOrcamento, setTotalOrcamento] = useState(0);
    const [isLoadingGerarOrcamento, setIsLoadingGerarOrcamento] = useState(false);
    const [isModalOpenOrcamento, setIsModalOpenOrcamento] = useState(false);
    const closeModalOrcamento = () => setIsModalOpenOrcamento(false);
    const removerProdutoOrcamento = (id) => {
        setSelectedProducts((prevSelectedProducts) =>
            prevSelectedProducts.filter((produtoId) => produtoId !== id)
        );

        setSelectedProductDetails((prevSelectedProductDetails) =>
            prevSelectedProductDetails.filter((produto) => produto.produto_id !== id)
        );
    };

    const removerProdutoListaProdutos = (id) => {
        setSelectedProducts((prevSelectedProducts) =>
            prevSelectedProducts.filter((produtoId) => produtoId !== id)
        );

        setSelectedProductDetails((prevSelectedProductDetails) =>
            prevSelectedProductDetails.filter((produto) => produto.produto_id !== id)
        );
    };

    const openModalOrcamento = () => {
        setIsModalOpenOrcamento(true);
    };
    const handleCancelOrcamento = () => {
        closeModalOrcamento();
    };

    const clearSelection = () => {
        setSelectedProducts([]);
        setSelectedProductDetails([]);
    }

    const handleClickGerarOrcamento = () => {
        setIsLoadingGerarOrcamento(true);
        handleGerarOrcamento();
    };

    const handleQuantidadeChange = (id, quantidade) => {
        setSelectedProductDetails(prevProdutos =>
            prevProdutos.map(produto => {
                if (produto.produto_id === id) {
                    if (quantidade === "" || isNaN(quantidade)) {
                        return { ...produto, quantidade_orcamento: "" };
                    }

                    let novaQuantidade = Math.max(1, Math.min(quantidade, produto.quantidade));

                    if (quantidade > produto.quantidade && produto.quantidade_orcamento !== quantidade) {
                        toast({
                            title: `Quantidade indisponível! O máximo em estoque é ${produto.quantidade}.`,
                            description: "",
                            status: 'error',
                            isClosable: true,
                            duration: 1000,
                        });
                    }

                    return { ...produto, quantidade_orcamento: novaQuantidade };
                }
                return produto;
            })
        );
    };

    const handleBlur = (id, produtoQuantidade) => {
        setSelectedProductDetails(prevProdutos =>
            prevProdutos.map(produto => {
                if (produto.produto_id === id && produto.quantidade_orcamento === "") {
                    return { ...produto, quantidade_orcamento: 1 };
                }
                return produto;
            })
        );
    };

    const handleDescontoChange = (e) => {
        let value = e.target.value;

        value = value.replace(/[^0-9,]/g, '');

        const parts = value.split(',');
        if (parts.length > 2) {
            value = parts[0] + ',' + parts.slice(1).join('');
        }

        if (value > 100) {
            value = 100;
        }

        if (value < 0) {
            value = 0;
        }

        setDesconto(value);
    };



    // useEffect(() => {
    //     const subTotal = calcularSubtotal();
    //     setSubTotalOrcamento(subTotal);

    //     const descontoValor = calcularDesconto(subTotal);
    //     setTotalOrcamento(subTotal - descontoValor);

    //     const descontoReais = calcularDesconto();
    //     setDescontoReais(descontoReais);
    // }, [selectedProductDetails, desconto]);

    // const calcularSubtotal = () => {
    //     return selectedProductDetails.reduce((total, produto) => total + (produto.valor_venda * (produto.quantidade_orcamento || 1)), 0);
    // };

    // const calcularDesconto = () => {
    //     return (calcularSubtotal() * desconto) / 100;
    // };

    // const calcularTotal = () => {
    //     return calcularSubtotal() - calcularDesconto();
    // };


    const calcularSubtotal = () => {
        return selectedProductDetails.reduce((total, produto) => total + (produto.valor_venda * (produto.quantidade_orcamento || 1)), 0);
    };

    const calcularDesconto = (subtotal) => {
        const percentual = parseFloat(String(desconto).replace(',', '.')) || 0;
        return (subtotal * percentual) / 100;
    };


    useEffect(() => {
        const subTotalProdutos = calcularSubtotal();

        const freteValor = parseFormattedCurrency(valorFrete);

        const descontoValor = calcularDesconto(subTotalProdutos);

        const totalFinal = subTotalProdutos + freteValor - descontoValor;

        setSubTotalOrcamento(subTotalProdutos);
        setDescontoReais(descontoValor);
        setTotalOrcamento(totalFinal);

    }, [selectedProductDetails, desconto, valorFrete]);

    const formatarPreco = (valor) => {
        const numero = Number(valor);
        if (isNaN(numero)) return "0,00";
        return numero.toFixed(2).replace(".", ",");
    };

    const handleGerarOrcamento = () => {
        if (selectedProductDetails && selectedProductDetails.length == 0) {
            toast({
                title: `Nenhum produto selecionado.`,
                status: 'error',
                isClosable: true,
            })
            setIsLoadingGerarOrcamento(false);
            return;
        }
        setLoading(true);
        try {
            (async () => {

                const userString = window.localStorage.getItem("user");
                const user = JSON.parse(userString);
                const requestData = {
                    produtos: selectedProductDetails,
                    nome_cliente: nomeCliente,
                    documento_cliente: documentoCliente,
                    endereco_cliente: enderecoCliente,
                    telefone_cliente: telefoneCliente,
                    email_cliente: emailCliente,
                    valor_frete: parseFormattedCurrency(valorFrete),
                    vendedor: vendedor,
                    desconto: descontoReais,
                    sub_total: subTotalOrcamento,
                    total: totalOrcamento,
                    userId: user.id,
                    observacoes: observacoes
                };

                const response = await gerarOrcamento(requestData);
                if (response === false) {
                    toast({
                        title: `Erro ao gerar orçamento.`,
                        status: 'error',
                        isClosable: true,
                    })
                    setLoading(false);
                    return;
                }

                const blob = new Blob([response], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;

                const now = new Date();
                const dateString = now.toISOString().replace(/[-:T.]/g, "");
                const fileName = `orcamento_taga_${dateString}.pdf`;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                setLoading(false);
            })();
        } catch {
            toast({
                title: `Erro ao gerar orçamento.`,
                status: 'error',
                isClosable: true,
            })
            setLoading(false);
            return false;
        }
        setIsLoadingGerarOrcamento(false);
    }


    useEffect(() => {
        const savedSelection = JSON.parse(localStorage.getItem("selectedProducts")) || [];
        setSelectedProducts(savedSelection);

        const queryParams = new URLSearchParams(location.search);
        var id = queryParams.get('id');
        var id_anuncio = queryParams.get('id_anuncio');
        if (id == null) {
            id = '';
        }
        if (id_anuncio == null) {
            id_anuncio = '';
        }
        setFiltroId(id || "");
        setFiltroIdAnuncio(id_anuncio || "");
        const timeoutId = setTimeout(() => {
            if ((id_anuncio != null && id_anuncio != "") || (id != null && id != "")) {
                pesquisarProduto(1, id, id_anuncio);
            }
        }, 100);

        const fecharMenuAoClicarFora = (event) => {
            const elementos = document.getElementsByClassName("acoes_button");
            if (listaRef.current && !listaRef.current.contains(event.target)) {
                let clicadoEmAcoesButton = false;
                for (let i = 0; i < elementos.length; i++) {
                    if (elementos[i] === event.target || elementos[i].contains(event.target)) {
                        clicadoEmAcoesButton = true;
                        break;
                    }
                }
                if (!clicadoEmAcoesButton) {
                    setMenuVisivel(false);
                }
            }
        };
        document.addEventListener('mousedown', fecharMenuAoClicarFora);
        return () => {
            document.removeEventListener('mousedown', fecharMenuAoClicarFora);
        };
    }, [location]);

    const handleRecrearAnuncio = (produto) => {
        setProdutoParaRecrear(produto);
        setIsModalConfirmarOpen(true);
        setMenuVisivel(false);
    };

    const handleCloseConfirmar = () => {
        setIsModalConfirmarOpen(false);
        setProdutoParaRecrear(null);
    };

    const handleConfirmarRecrear = async () => {
        handleCloseConfirmar();
        setResultadoRecrear([]);
        setIsLoadingRecrear(true);
        setIsModalRecrearOpen(true);

        if (!produtoParaRecrear) return;

        try {
            const response = await recrearAnuncioML(produtoParaRecrear.estoque_id);

            if (response && Array.isArray(response)) {
                setResultadoRecrear(response);
            } else {
                setResultadoRecrear([{
                    conta: 'Erro',
                    status: 'erro',
                    mensagem: 'Não foi possível processar a solicitação. Resposta inesperada da API.',
                    id_ml_antigo: null,
                    id_ml_novo: null
                }]);
            }
        } catch (error) {
            setResultadoRecrear([{
                conta: 'Erro',
                status: 'erro',
                mensagem: 'Erro de conexão ao tentar recriar o anúncio.',
                id_ml_antigo: null,
                id_ml_novo: null
            }]);
        } finally {
            setIsLoadingRecrear(false);
            setProdutoParaRecrear(null);
        }
    };

    const closeModalRecrear = () => {
        setIsModalRecrearOpen(false);
        setResultadoRecrear([]);
        pesquisarProduto(pagina);
    };


    const handleChangeAcaoIndiv = (idProduto, acao) => {
        handleChangeAcaoMassa({ target: { value: acao }, id_produto: idProduto });
    };

    const handleChangeAcaoMassa = (event) => {
        const valorSelecionado = event.target.value;
        if (valorSelecionado == "gerar_orcamento") {
            openModalOrcamento();
        } else if (valorSelecionado === "gerar_lista_produtos") {
            setIsOpenModalListaProdutos(true);
        } else if (valorSelecionado === "bloquear_massa" || valorSelecionado === "ativar_massa") {
            if (selectedProducts.length === 0) {
                toast({
                    title: "Nenhum produto selecionado",
                    description: "Selecione ao menos um produto para executar esta ação.",
                    status: 'warning',
                    isClosable: true,
                });
                setSelecaoMassa("");
                return;
            }

            setConfirmBulkModalData({
                action: valorSelecionado === "bloquear_massa" ? 'bloquear' : 'ativar',
                status: valorSelecionado === "bloquear_massa" ? 1 : 0,
                count: selectedProducts.length
            });
            setIsConfirmBulkModalOpen(true);

        } else {
            setMenuVisivel(false);
            var idProduto = event.id_produto;
            if (!idProduto) {
                toast({
                    title: `Nenhum produto selecionado`,
                    status: 'error',
                    isClosable: true,
                    duration: 1000,
                });
                return;
            }
            if (valorSelecionado === "bloquear_produto") {
                setConfirmBulkModalData({ action: 'bloquear', status: 1, count: 1, produtoId: idProduto });
                setIsConfirmBulkModalOpen(true);
            } else if (valorSelecionado === "desbloquear_produto") {
                handleSetBloqueioProduto(idProduto, 0)
            }
        }

    };

    const handleSetBloqueioProduto = async (idProduto, bloquear, motivo = null) => {
        setLoading(true);
        try {
            const response = await setBloqueioProduto(idProduto, bloquear, motivo || null);
            if (response != false) {
                toast({
                    title: `Produto atualizado com sucesso!`,
                    status: 'success',
                    isClosable: true,
                })

                const produtoEncontrado = produtos.find(produto => produto.produto_id === idProduto);
                if (produtoEncontrado) {
                    produtoEncontrado.bloqueado = bloquear;
                    setProdutos([...produtos]);
                }
            } else {
                toast({
                    title: `Erro ao atualizar produto.`,
                    status: 'error',
                    isClosable: true,
                })
            }
        } catch {
            toast({
                title: `Erro ao atualizar produto.`,
                status: 'error',
                isClosable: true,
            })
        } finally {
            setLoading(false);
        }
    }

    function limitarCaracteres(str, limite) {
        if (str.length > limite) {
            return str.slice(0, limite) + "...";
        }
        return str;
    }

    const handleAnterior = () => {
        let paginaAux = pagina - 1;
        if (paginaAux > 1) {
            setPagina(paginaAux);
        } else {
            setPagina(1);
        }
        pesquisarProduto(paginaAux);
    }

    const handleProxima = () => {
        let paginaAux = pagina + 1;
        setPagina(paginaAux);
        pesquisarProduto(paginaAux);
    }

    const handlePrimeira = () => {
        setPagina(1);
        pesquisarProduto(1);
    }

    const handleUltima = () => {
        setPagina(ultimaPagina);
        pesquisarProduto(ultimaPagina);
    }

    const [filtroNome, setFiltroNome] = useState('');
    const [filtroCodGlobal, setFiltroCodGlobal] = useState('');
    const [filtroAplicacao, setFiltroAplicacao] = useState('');
    const [filtroId, setFiltroId] = useState('');
    const [filtroIdAnuncio, setFiltroIdAnuncio] = useState('');
    const [filtroCodFornecedor, setFiltroCodFornecedor] = useState('');
    const [filtroEstoqueTaga, setFiltroEstoqueTaga] = useState(false);
    const [filtroStatusFornecedor, setFiltroStatusFornecedor] = useState("morelate-vannucci-isapa-brcompany-autolatina-lng-cba-msam-blparts");
    const [filtroStatusMktplaces, setFiltroStatusMktplaces] = useState("0-1-2-3");
    const [filtroStatusProduto, setFiltroStatusProduto] = useState('3');

    const handleChangeStatusProduto = (event) => { setFiltroStatusProduto(event.target.value); };
    const handleChangeFiltroNome = (event) => { setFiltroNome(event.target.value); };
    const handleChangeFiltroCodGlobal = (event) => { setFiltroCodGlobal(event.target.value); };
    const handleChangeFiltroAplicacao = (event) => { setFiltroAplicacao(event.target.value); };
    const handleChangeFiltroId = (event) => { setFiltroId(event.target.value); };
    const handleChangeFiltroIdAnuncio = (event) => { setFiltroIdAnuncio(event.target.value); };
    const handleChangeFiltroCodFornecedor = (event) => { setFiltroCodFornecedor(event.target.value); };
    const handleChangeFiltroEstoqueTaga = (event) => { setFiltroEstoqueTaga(event.target.checked); };

    const [selectedOptionsStatusMktplaces, setSelectedOptionsStatusMktplaces] = useState([{ label: "Sem anúncio", value: "0" }, { label: "Mercado Livre", value: "1" },
    { label: "Magalu", value: "2" }, { label: "Amazon", value: "3" }]);
    const handleSelectedOptionsStatusChangeMktplace = (options) => {
        setSelectedOptionsStatusMktplaces(options);
        let concatenatedString = "";
        if (options && options.length > 0) {
            for (let i = 0; i < options.length; i++) {
                if (options[i] && options[i].value) {
                    concatenatedString += options[i].value;
                    if (i !== options.length - 1) {
                        concatenatedString += "-";
                    }
                }
            }
        }
        handleChangeFiltroStatusMktplace(concatenatedString);
    };

    const handleChangeFiltroStatusMktplace = (value) => {
        setFiltroStatusMktplaces(value);
    };

    const [selectedOptionsStatusFornecedor, setSelectedOptionsStatusFornecedor] = useState([{ label: "Morelate", value: "morelate" },
    { label: "Vannucci", value: "vannucci" }, { label: "Isapa", value: "isapa" }, { label: "BRCompany", value: "brcompany" }, { label: "Autolatina", value: "autolatina" }, { label: "LNG", value: "lng" }, { label: "CBA", value: "cba" }, { label: "MSAM", value: "msam" }, { label: "BL Parts", value: "blparts" }]);
    const handleSelectedOptionsStatusChange = (options) => {
        setSelectedOptionsStatusFornecedor(options);
        let concatenatedString = "";
        if (options && options.length > 0) {
            for (let i = 0; i < options.length; i++) {
                if (options[i] && options[i].value) {
                    concatenatedString += options[i].value;
                    if (i !== options.length - 1) {
                        concatenatedString += "-";
                    }
                }
            }
        }
        handleChangeFiltroStatus(concatenatedString);
    };


    const handleChangeFiltroStatus = (value) => {
        setFiltroStatusFornecedor(value);
    };

    const handlePesquisar = () => {
        setPagina(1);
        pesquisarProduto();
    };

    const limparFiltros = () => {
        setFiltroNome("");
        setFiltroCodGlobal("");
        setFiltroAplicacao("");
        setFiltroId("");
        setFiltroIdAnuncio("");
        setFiltroCodFornecedor("");
        setFiltroEstoqueTaga("");
        setFiltroStatusProduto("3")
        // setFiltroStatusFornecedor("");
        // setSelectedOptionsStatusFornecedor([]);
        // setSelectedOptionsStatusMktplaces([]);
    };

    function pesquisarProduto(paginaAux, id = '', id_anuncio = '') {
        setLoading(true);
        setIntegracoes({});
        try {
            (async () => {
                var filtroIdUsado = filtroId;
                var filtroIdAnuncioUsado = filtroIdAnuncio;
                if (id != '') {
                    filtroIdUsado = id;
                }
                if (id_anuncio != '') {
                    filtroIdAnuncioUsado = id_anuncio;
                }
                var consulta = "nome=" + filtroNome + "&codGlobal=" + filtroCodGlobal + "&aplicacao=" + filtroAplicacao + "&id=" + filtroIdUsado + "&idAnuncio=" + filtroIdAnuncioUsado + "&codFor=" + filtroCodFornecedor + "&estoqueTaga=" + filtroEstoqueTaga + "&fornecedor=" + filtroStatusFornecedor + "&pagina=" + paginaAux + "&mktplace=" + filtroStatusMktplaces + "&status=" + filtroStatusProduto;
                const responseProdutos = await getProdutos(consulta);
                console.log("responseProdutos =", responseProdutos)
                if (responseProdutos != false) {
                    setProdutos(responseProdutos.data);
                    setUltimaPagina(responseProdutos.last_page)
                    setTotalRegistros(responseProdutos.total);
                    setPaginateFrom(responseProdutos.from);
                    setPaginateTo(responseProdutos.to);
                    setBuscaBool(false);

                    const estoqueIds = responseProdutos.data.map(p => p.estoque_id);
                    if (estoqueIds.length > 0) {
                        setLoadingIntegracoes(true);
                        const responseIntegracoes = await getIntegracoes({ ids: estoqueIds });
                        setIntegracoes(responseIntegracoes);
                        setLoadingIntegracoes(false);
                    }
                } else {
                    setProdutos([]);
                    setBuscaBool(true);
                }
                setTimeout(() => {
                    setLoading(false);
                }, 500);
            })();
        }
        catch {
            return false;
        }
    }

    const openModal = (produto) => {
        if (produto.fornecedor_id == 1) {
            produto.fornecedor = "MORELATE";
        } else if (produto.fornecedor_id == 2) {
            produto.fornecedor = "VANNUCCI";
        } else if (produto.fornecedor_id == 3) {
            produto.fornecedor = "ISAPA";
        } else if (produto.fornecedor_id == 4) {
            produto.fornecedor = "BRCOMPANY";
        } else if (produto.fornecedor_id == 6) {
            produto.fornecedor = "LNG";
        } else if (produto.fornecedor_id == 7) {
            produto.fornecedor = "CBA";
        } else if (produto.fornecedor_id == 8) {
            produto.fornecedor = "MSAM";
        } else if (produto.fornecedor_id == 9) {
            produto.fornecedor = "BLPARTS";
        }

        setProdutoView(produto);
        setIsModalOpen(true);
    };

    const openModalML = (id_ml, conta) => {
        setIsLoadingSkeletonML(true);
        setProdutoViewML([]);
        setPrecoML("")
        setPremiumML(null)
        setEstoqueML("")
        setStatusML("")
        setContaML("");
        setIsModalOpenML(true);
        try {
            (async () => {
                const responseAnuncio = await getAnuncioML(id_ml, conta);
                if (responseAnuncio.erro == true) {
                    toast({
                        title: `Erro ao consultar anúncio.`,
                        description: responseAnuncio.msg,
                        status: 'error',
                        isClosable: true,
                        duration: 4000,
                    });
                    setIsModalOpenML(false);
                    return;
                }

                if (responseAnuncio != false) {
                    setProdutoViewML(responseAnuncio.data);
                    const premium = responseAnuncio.premium && responseAnuncio.premium.preco_classico != null ? responseAnuncio.premium : null;
                    setPremiumML(premium);
                    setPrecoML(premium ? premium.preco_classico : responseAnuncio.data.price)
                    setEstoqueML(responseAnuncio.data.initial_quantity)
                    setStatusML(responseAnuncio.data.status)
                    setContaML(conta);
                    setIsModalOpenML(true);
                } else {
                    toast({
                        title: `Erro ao consultar anúncio.`,
                        description: responseAnuncio.msg,
                        status: 'error',
                        isClosable: true,
                        duration: 1000,
                    });
                    setIsModalOpenML(false);
                }
                setIsLoadingSkeletonML(false);
            })();
        }
        catch {
            setIsModalOpenML(false);
            setIsLoadingSkeletonML(false);
            return false;
        }
    };

    const openModalMagalu = (id_magalu) => {
        setIsLoadingSkeletonMagalu(true);
        setProdutoViewMagalu([]);
        setPrecoMagalu("")
        setEstoqueMagalu("")
        setStatusMagalu("")
        setIsModalOpenMagalu(true);
        try {
            (async () => {
                const responseAnuncio = await getAnuncioMagalu(id_magalu);
                if (responseAnuncio.erro == true) {
                    toast({
                        title: `Erro ao consultar anúncio.`,
                        description: responseAnuncio.msg,
                        status: 'error',
                        isClosable: true,
                        duration: 4000,
                    });
                    setIsModalOpenMagalu(false);
                    return;
                }

                if (responseAnuncio != false) {
                    setProdutoViewMagalu(responseAnuncio.data);
                    setPrecoMagalu(responseAnuncio.data.Price.SalePrice)
                    setEstoqueMagalu(responseAnuncio.data.StockQuantity)
                    setStatusMagalu(responseAnuncio.data.Status)
                    setIsModalOpenMagalu(true);
                } else {
                    toast({
                        title: `Erro ao consultar anúncio.`,
                        description: responseAnuncio.msg,
                        status: 'error',
                        isClosable: true,
                        duration: 1000,
                    });
                    setIsModalOpenMagalu(false);
                }
                setIsLoadingSkeletonMagalu(false);
            })();
        }
        catch {
            setIsModalOpenMagalu(false);
            setIsLoadingSkeletonMagalu(false);
            return false;
        }
    };

    const openModalAmazon = (id_amazon) => {
        setIsLoadingSkeletonAmazon(true);
        setProdutoViewAmazon([]);
        setPrecoAmazon("")
        setEstoqueAmazon("")
        setStatusAmazon("")
        setIsModalOpenAmazon(true);
        try {
            (async () => {
                const responseAnuncio = await getAnuncioAmazon(id_amazon);
                if (responseAnuncio.erro == true) {
                    toast({
                        title: `Erro ao consultar anúncio.`,
                        description: responseAnuncio.msg,
                        status: 'error',
                        isClosable: true,
                        duration: 4000,
                    });
                    setIsModalOpenAmazon(false);
                    return;
                }

                if (responseAnuncio != false) {
                    setProdutoViewAmazon(responseAnuncio.data);
                    setPrecoAmazon(responseAnuncio.data.Price.SalePrice)
                    setEstoqueAmazon(responseAnuncio.data.StockQuantity)
                    setStatusAmazon(responseAnuncio.data.Status)
                    setIsModalOpenAmazon(true);
                } else {
                    toast({
                        title: `Erro ao consultar anúncio.`,
                        description: responseAnuncio.msg,
                        status: 'error',
                        isClosable: true,
                        duration: 1000,
                    });
                    setIsModalOpenAmazon(false);
                }
                setIsLoadingSkeletonAmazon(false);
            })();
        }
        catch {
            setIsModalOpenAmazon(false);
            setIsLoadingSkeletonAmazon(false);
            return false;
        }
    };

    const openModalTAGA = (produto_id) => {
        setProdutoViewTAGA([]);
        setPrecoTAGA("");
        setEstoqueTAGA("");
        setEstoqueFisicoTAGA("");
        setCodigoSimilaresTAGA("");
        setIsModalOpenTAGA(true);
        try {
            (async () => {
                const responseProduto = await getProdutoId(produto_id);
                if (responseProduto.erro == true) {
                    toast({
                        title: `Erro ao consultar produto.`,
                        description: responseProduto.msg,
                        status: 'error',
                        isClosable: true,
                        duration: 4000,
                    });
                    setIsModalOpenTAGA(false);
                    return;
                }

                if (responseProduto != false) {
                    setProdutoViewTAGA(responseProduto.data);
                    setPrecoTAGA(responseProduto.data.preco)
                    setEstoqueTAGA(responseProduto.data.estoque)
                    setEstoqueFisicoTAGA(responseProduto.data.localizacao_estoques);
                    setCodigoSimilaresTAGA(responseProduto.data.codigo_similares || "");
                    setIsModalOpenTAGA(true);
                } else {
                    toast({
                        title: `Erro ao consultar produto.`,
                        description: responseProduto.msg,
                        status: 'error',
                        isClosable: true,
                        duration: 1000,
                    });
                    setIsModalOpenTAGA(false);
                }
                setIsLoadingSkeletonML(false);
            })();
        }
        catch {
            setIsModalOpenTAGA(false);
            return false;
        }
    }

    const handlePriceChange = (e, mktplace) => {
        let value = e.target.value;
        value = value.replace(/[^0-9,]/g, "");

        if (value.includes(",")) {
            const [integerPart, decimalPart] = value.split(",");
            value = integerPart + "," + decimalPart.substring(0, 2);
        }

        if (mktplace == "Mercado Livre") {
            setPrecoML(value);
        } else if (mktplace == "TAGA") {
            setPrecoTAGA(value);
        }
    };

    const atualizaAnuncioML = (id_ml) => {
        setIsLoadingBtnML(true);
        try {
            (async () => {
                const data = {
                    "id_ml": id_ml,
                    "conta": contaML,
                    "preco": precoML,
                    "estoque": estoqueML,
                    "status": statusML
                }
                const responseAnuncio = await putAnuncioML(data);
                if (responseAnuncio != false && responseAnuncio.http_code == 200) {
                    toast({
                        title: `Anúncio atualizado com sucesso!`,
                        status: 'success',
                        isClosable: true,
                        duration: 1000,
                    })
                } else {
                    toast({
                        title: `ERRO ao atualizar anúncio.`,
                        description: responseAnuncio.msg,
                        status: 'error',
                        isClosable: true,
                        duration: 1000,
                    });
                }
                setIsLoadingBtnML(false);
            })();
        }
        catch {
            setIsLoadingBtnML(false);
            return false;
        }
    };


    const atualizaProdutoTAGA = (id) => {
        setIsLoadingBtnTAGA(true);
        try {
            (async () => {
                const data = {
                    "id": id,
                    "preco": precoTAGA,
                    "estoque": estoqueTAGA,
                    "localizacao_estoque": estoqueFisicoTAGA,
                    "codigo_similares": codigoSimilaresTAGA
                }
                const responseProduto = await putProdutoTAGA(data);
                if (responseProduto != false && responseProduto.http_code == 200) {
                    toast({
                        title: `Produto atualizado com sucesso!`,
                        status: 'success',
                        isClosable: true,
                        duration: 1000,
                    })
                } else {
                    toast({
                        title: `ERRO ao atualizar Produto.`,
                        description: responseProduto.msg,
                        status: 'error',
                        isClosable: true,
                        duration: 1000,
                    });
                }
                setIsLoadingBtnTAGA(false);
            })();
        }
        catch {
            setIsLoadingBtnTAGA(false);
            return false;
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const closeModalML = () => {
        setIsModalOpenML(false);
    };

    const closeModalMagalu = () => {
        setIsModalOpenMagalu(false);
    };

    const closeModalAmazon = () => {
        setIsModalOpenAmazon(false);
    };

    const closeModalTAGA = () => {
        setIsModalOpenTAGA(false);
    };

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            pesquisarProduto();
        }
    }

    const getFornecedor = (produto) => {
        let nome = "MORELATE";
        if (produto.fornecedor_id == 2) {
            nome = "VANNUCCI";
        } else if (produto.fornecedor_id == 3) {
            nome = "ISAPA";
        } else if (produto.fornecedor_id == 4) {
            nome = "BRCOMPANY";
        } else if (produto.fornecedor_id == 5) {
            nome = "AUTOLATINA";
        } else if (produto.fornecedor_id == 6) {
            nome = "LNG";
        } else if (produto.fornecedor_id == 7) {
            nome = "CBA";
        } else if (produto.fornecedor_id == 8) {
            nome = "MSAM";
        } else if (produto.fornecedor_id == 9) {
            nome = "BLPARTS";
        }
        return nome;
    };

    const handleClickCopyIdAnuncioML = (id) => {
        navigator.clipboard.writeText(`${id}`);
        const checkIcon = ReactDOMServer.renderToString(<FaClipboardCheck fontSize="0.8rem" color="#136b19" />);
        $('#copy_anuncio_ml_' + id).html(checkIcon);
        setTimeout(() => {
            const copyIcon = ReactDOMServer.renderToString(<FaCopy fontSize="0.8rem" />);
            $('#copy_anuncio_ml_' + id).html(copyIcon);
        }, 1000);
    };

    const handleClickCopyIdAnuncioMagalu = (id) => {
        navigator.clipboard.writeText(`${id}`);
        const checkIcon = ReactDOMServer.renderToString(<FaClipboardCheck fontSize="0.8rem" color="#136b19" />);
        $('#copy_anuncio_magalu_' + id).html(checkIcon);
        setTimeout(() => {
            const copyIcon = ReactDOMServer.renderToString(<FaCopy fontSize="0.8rem" />);
            $('#copy_anuncio_magalu_' + id).html(copyIcon);
        }, 1000);
    };

    const handleClickCopyIdAnuncioAmazon = (id) => {
        navigator.clipboard.writeText(`${id}`);
        const checkIcon = ReactDOMServer.renderToString(<FaClipboardCheck fontSize="0.8rem" color="#136b19" />);
        $('#copy_anuncio_amazon_' + id).html(checkIcon);
        setTimeout(() => {
            const copyIcon = ReactDOMServer.renderToString(<FaCopy fontSize="0.8rem" />);
            $('#copy_anuncio_amazon_' + id).html(copyIcon);
        }, 1000);
    };

    const handleClickCopyLinkShops = (link) => {
        navigator.clipboard.writeText(link);
    };

    function getImagemFornecedor(fornecedor) {
        var imagem = "";
        if (fornecedor == "1") {
            imagem = "/logo_morelate.webp";
        } else if (fornecedor == "2") {
            imagem = "/logo_vannucci.webp"
        } else if (fornecedor == "3") {
            imagem = "/logo_isapa.webp";
        } else if (fornecedor == "4") {
            imagem = "/logo_brcompany.webp";
        } else if (fornecedor == "5") {
            imagem = "/logo_autolatina.webp";
        } else if (fornecedor == "6") {
            imagem = "/logo_lng.webp";
        } else if (fornecedor == "7") {
            imagem = "/logo_cba.webp";
        } else if (fornecedor == "8") {
            imagem = "/logo_msam.webp";
        } else if (fornecedor == "9") {
            imagem = "/logo_blparts.webp";
        }
        return imagem;
    }

    const formatarParaBRL = (valor) => {
        const numero = Number(valor);
        if (isNaN(numero)) {
            return "R$ 0,00";
        }
        return numero.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
    };

    const handleClickCopyLinkML = (id_anuncio) => {
        const link = `https://produto.mercadolivre.com.br/MLB-${id_anuncio.replace("MLB", '')}`;
        navigator.clipboard.writeText(link);
    };

    const abrirProdutoEcommerce = async (produtoId) => {
        const novaAba = window.open('', '_blank');
        try {
            const url = await getLinkEcommerceProduto(produtoId);
            if (!url) {
                if (novaAba) novaAba.close();
                toast({
                    title: "Produto sem link no e-commerce",
                    status: "warning",
                    duration: 3000,
                    isClosable: true,
                });
                return;
            }
            if (novaAba) {
                novaAba.location.href = url;
            } else {
                window.location.href = url;
            }
        } catch (e) {
            if (novaAba) novaAba.close();
            toast({
                title: "Falha ao abrir produto no e-commerce",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        }
    };

    const openTicketModal = (produto) => {
        setSelectedProductForTicket(produto);
        setIsTicketModalOpen(true);
        setMenuVisivel(false);
    };

    const closeTicketModal = () => {
        setIsTicketModalOpen(false);
        setSelectedProductForTicket(null);
        setTicketTemplate('');
        setIsCreatingTicket(false);
    };

    const handleConfirmCreateTicket = async () => {
        if (!ticketTemplate || !selectedProductForTicket) {
            toast({
                title: "Erro",
                description: "Por favor, selecione um problema.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        setIsCreatingTicket(true);

        const userString = window.localStorage.getItem("user");
        if (!userString) {
            toast({
                title: "Erro de Autenticação",
                description: "Usuário não encontrado. Faça login novamente.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
            setIsCreatingTicket(false);
            return;
        }
        const user = JSON.parse(userString);
        const currentUserId = user.id;

        const prioridadeString = 'baixa';

        const categoriaIdParaAnunciosML = 10;

        const formData = new FormData();

        formData.append('subject', `Ajustar Anúncio/Produto ${selectedProductForTicket.produto_id}`);
        formData.append('description', ticketTemplate);
        formData.append('priority', prioridadeString);
        formData.append('categoryIds[]', categoriaIdParaAnunciosML);
        formData.append('assigneeIds[]', currentUserId);

        formData.append('linkedItems[]', selectedProductForTicket.produto_id);

        try {
            const response = await createTicket(formData);

            toast({
                title: "Ticket Criado com Sucesso!",
                description: `O Ticket #${response.data.ticket_id} foi aberto.`,
                status: "success",
                duration: 5000,
                isClosable: true,
            });

            window.location.href = `https://admin.tagaautopartes.com.br/tickets/${response.data.ticket_id}`;
            // closeTicketModal();

        } catch (error) {
            console.error("Erro ao criar ticket:", error.response?.data || error);
            toast({
                title: "Erro ao criar ticket",
                description: "Não foi possível criar o ticket. Verifique o console ou tente novamente.",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        } finally {
            setIsCreatingTicket(false);
        }
    };

    return (
        <>
            <ScrollToTop />
            {loading && <Preloader />}
            <Box ml={{ base: 0, md: 2, lg: 6 }} textAlign="center" fontSize="xl" py={4} bg="white" minH="100vh">
                <Box textAlign="center" ml={4} fontSize="xl">
                    <Text color={"#F68633"} fontWeight={"bold"}>
                        PRODUTOS
                    </Text>
                </Box>
                <Box mx={{ base: 1, md: 12, lg: 25 }} mt={0} boxShadow="md" borderRadius="lg" px={0} mb={{ base: "2", md: "8", lg: "8" }} pb={2}>
                    <Box
                        mx={{ base: "auto", md: "auto", lg: 6 }}
                        p={2}
                        pt={0}
                        pl={2}
                        mt={12}
                        border="1px solid #FF9F59"
                        boxShadow="md"
                        borderRadius="lg"
                    >
                        <Text
                            fontSize="8px"
                            textAlign="center"
                            color="#F68633"
                            fontWeight="bold"
                            position="relative"
                            top="-6px"
                            bg="white"
                            w={"50px"}
                            px={1}
                            borderRadius={"lg"}
                            border="1px solid #FF9F59"
                        >
                            FILTROS
                        </Text>
                        <Flex align={"center"} justifyContent={"center"} flexDirection={{ base: "column", md: "row", lg: "row" }}>
                            <Box mr={4} >
                                <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"8px"} fontWeight={"bold"}>
                                    ID/SKU
                                </Text>
                                <Input
                                    boxShadow='lg'
                                    bg={'white'}
                                    color={"black"}
                                    placeholder="6158"
                                    w={{ base: "300px", md: "150px", lg: "200px", xl: "200px", "2xl": "200px" }}
                                    h={{ base: "35px", md: "35px", lg: "35px" }}
                                    _placeholder={{
                                        color: 'black',
                                        opacity: 0.6,
                                    }}
                                    _focus={{
                                        border: 'none',
                                    }}
                                    value={filtroId}
                                    onChange={handleChangeFiltroId}
                                    fontSize={"12px"}
                                />
                            </Box>
                            <Box mr={4} >
                                <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"8px"} fontWeight={"bold"}>
                                    CÓDIGO GLOBAL
                                </Text>
                                <Input
                                    boxShadow='lg'
                                    bg={'white'}
                                    color={"black"}
                                    placeholder="20835246"
                                    fontSize={"12px"}
                                    w={{ base: "300px", md: "150px", lg: "200px", xl: "200px", "2xl": "200px" }}
                                    h={{ base: "35px", md: "35px", lg: "35px" }}
                                    _placeholder={{
                                        color: 'black',
                                        opacity: 0.6,
                                    }}
                                    _focus={{
                                        border: 'none',
                                    }}
                                    value={filtroCodGlobal}
                                    onChange={handleChangeFiltroCodGlobal}
                                />
                            </Box>
                            <Box mr={4} >
                                <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"8px"} fontWeight={"bold"}>
                                    NOME
                                </Text>
                                <Input
                                    boxShadow='lg'
                                    bg={'white'}
                                    color={"black"}
                                    placeholder="CILINDRO MESTRE EMBREAGEM..."
                                    w={{ base: "300px", md: "150px", lg: "200px", xl: "200px", "2xl": "200px" }}
                                    h={{ base: "35px", md: "35px", lg: "35px" }}
                                    fontSize={"12px"}
                                    _placeholder={{
                                        color: 'black',
                                        opacity: 0.6,
                                    }}
                                    _focus={{
                                        border: 'none',
                                    }}
                                    value={filtroNome}
                                    onChange={handleChangeFiltroNome}
                                />
                            </Box>
                            <Box mr={4} mt={0} pt={0} >
                                <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"8px"} fontWeight={"bold"}>
                                    ID ANÚNCIO
                                </Text>
                                <Input
                                    boxShadow='lg'
                                    bg={'white'}
                                    color={"black"}
                                    placeholder="MLB3237818976"
                                    w={{ base: "300px", md: "150px", lg: "200px", xl: "200px", "2xl": "200px" }}
                                    h={{ base: "35px", md: "35px", lg: "35px" }}
                                    fontSize={"12px"}
                                    _placeholder={{ color: 'black', opacity: 0.6 }}
                                    _focus={{ border: 'none' }}
                                    value={filtroIdAnuncio}
                                    onChange={handleChangeFiltroIdAnuncio}
                                />
                            </Box>
                            <Box mr={4}>
                                <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"8px"} fontWeight={"bold"}>
                                    FORNECEDOR
                                </Text>
                                <Box
                                    w={{ base: "300px", md: "150px", lg: "200px", xl: "200px", "2xl": "200px" }}
                                    ml={2}
                                    boxShadow='lg'
                                >
                                    <MultipleSelectFornecedor selectedOptionsStatus={selectedOptionsStatusFornecedor} handleSelectedOptionsStatusChange={handleSelectedOptionsStatusChange} />
                                </Box>
                            </Box>
                        </Flex>
                        <Box ml={{ base: "4", md: "0" }}>
                            <Collapse in={isOpenFiltros} animateOpacity style={{ overflow: "visible" }}>
                                <Box pb={4}>
                                    <Flex mt={0} mr={2} align={"center"} justifyContent={"center"} flexDirection={{ base: "column", md: "row", lg: "row" }} height={"auto"}>
                                        <Box mr={4}>
                                            <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"8px"} fontWeight={"bold"}>
                                                CÓDIGO FORNECEDOR
                                            </Text>
                                            <Input
                                                boxShadow='lg'
                                                bg={'white'}
                                                color={"black"}
                                                placeholder="071911"
                                                w={{ base: "300px", md: "150px", lg: "200px", xl: "200px", "2xl": "200px" }}
                                                h={{ base: "35px", md: "35px", lg: "35px" }}
                                                fontSize={"12px"}
                                                _placeholder={{ color: 'black', opacity: 0.6 }}
                                                _focus={{ border: 'none' }}
                                                value={filtroCodFornecedor}
                                                onChange={handleChangeFiltroCodFornecedor}
                                            />
                                        </Box>
                                        <Box mr={4} >
                                            <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"8px"} fontWeight={"bold"}>
                                                APLICAÇÃO
                                            </Text>
                                            <Input
                                                boxShadow='lg'
                                                bg={'white'}
                                                color={"black"}
                                                placeholder="VOLVO FH12"
                                                fontSize={"12px"}
                                                w={{ base: "300px", md: "150px", lg: "200px", xl: "200px", "2xl": "200px" }}
                                                h={{ base: "35px", md: "35px", lg: "35px" }}
                                                _placeholder={{ color: 'black', opacity: 0.6 }}
                                                _focus={{ border: 'none' }}
                                                value={filtroAplicacao}
                                                onChange={handleChangeFiltroAplicacao}
                                            />
                                        </Box>
                                        <Box mr={4}>
                                            <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"8px"} fontWeight={"bold"}>
                                                STATUS
                                            </Text>
                                            <Box
                                                w={{ base: "300px", md: "150px", lg: "200px", xl: "200px", "2xl": "200px" }}
                                                boxShadow='lg'
                                                h={{ base: "35px", md: "35px", lg: "35px" }}
                                                borderRadius={"lg"}
                                            >
                                                <Select
                                                    placeholder="Selecione uma opção"
                                                    value={filtroStatusProduto}
                                                    onChange={handleChangeStatusProduto}
                                                    h={{ base: "35px", md: "35px", lg: "35px" }}
                                                >
                                                    <option value="3">Todos</option>
                                                    <option value="0">Ativos</option>
                                                    <option value="1">Bloqueados</option>
                                                    <option value="2">Bloqueados Temporariamente</option>
                                                </Select>
                                            </Box>
                                        </Box>
                                        <Box hidden mr={4}>
                                            <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"8px"} fontWeight={"bold"}>
                                                INTEGRAÇÕES
                                            </Text>
                                            <Box
                                                w={{ base: "300px", md: "150px", lg: "200px", xl: "200px", "2xl": "200px" }}
                                                boxShadow='lg'
                                                zIndex="10"
                                            >
                                                <MultipleSelectMktplaces selectedOptionsStatus={selectedOptionsStatusMktplaces} handleSelectedOptionsStatusChange={handleSelectedOptionsStatusChangeMktplace} />
                                            </Box>
                                        </Box>
                                        <Box mr={4}>
                                            <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"8px"} fontWeight={"bold"}>
                                                ESTOQUE TAGA
                                            </Text>
                                            <Box
                                                w={{ base: "300px", md: "150px", lg: "200px", xl: "200px", "2xl": "200px" }}
                                                h={{ base: "35px", md: "35px", lg: "35px" }}
                                            >
                                                <Checkbox mt={"2"} size='lg' colorScheme='orange' isChecked={filtroEstoqueTaga} onChange={handleChangeFiltroEstoqueTaga}>
                                                    <Text fontSize={"16px"}>Com estoque TAGA</Text>
                                                </Checkbox>
                                            </Box>
                                        </Box>
                                    </Flex>
                                    <Flex mt={2} align={"center"} justifyContent={"center"} flexDirection={{ base: "column", md: "row", lg: "row" }} height={"auto"}>

                                        <Box mr={4} w={{ base: "300px", md: "150px", lg: "200px", xl: "250px", "2xl": "300px" }}></Box>
                                        <Box mr={4} w={{ base: "300px", md: "150px", lg: "200px", xl: "250px", "2xl": "300px" }}></Box>
                                    </Flex>
                                </Box>
                            </Collapse>
                            <Flex justifyContent={"center"} mt={4}>
                                <Button
                                    bg="gray.100"
                                    borderRadius={"lg"}
                                    justifyContent={"center"}
                                    width={"200px"}
                                    fontSize={"12px"}
                                    onClick={handleAccordionChange}
                                    rightIcon={isOpenFiltros ? <ChevronUpIcon /> : <ChevronDownIcon />}
                                >
                                    {isOpenFiltros ? "Mostrar menos filtros" : "Mostrar mais filtros"}
                                </Button>
                            </Flex>
                        </Box>
                        <Box mt={2}>
                            <Button
                                bg={"#01695E"}
                                color={"white"}
                                _hover={{ bg: "white", color: "black", transition: 'background 0.8s, color 0.8s' }}
                                onClick={handlePesquisar}
                                boxShadow='lg'
                            >
                                <FaSearch boxShadow='lg' /> <Text fontSize='12px' ml={"2"}>Pesquisar</Text>
                            </Button>
                            <Button
                                ml={2}
                                bg={"#FF0000"}
                                color={"white"}
                                _hover={{ bg: "white", color: "black", transition: 'background 0.8s, color 0.8s' }}
                                onClick={limparFiltros}
                                boxShadow='lg'
                            >
                                X <Text fontSize='12px' ml={"2"}>Limpar</Text>
                            </Button>
                        </Box>
                    </Box>

                    <Box
                        mx={{ base: "auto", md: "auto", lg: 6 }}
                        p={2}
                        pt={0}
                        pl={2}
                        mt={2}
                        border="1px solid"
                        borderColor="gray.200"
                        boxShadow="md"
                        borderRadius="lg"
                        bg={"#FF9F59"}
                        h={{ base: "auto", md: "60px" }}
                    >
                        <Text
                            fontSize="8px"
                            textAlign="center"
                            color="#F68633"
                            fontWeight="bold"
                            position="relative"
                            top="-6px"
                            bg="white"
                            w={"36px"}
                            px={1}
                            borderRadius={"lg"}
                            border="1px solid #FF9F59"
                        >
                            AÇÕES
                        </Text>
                        <Flex flexDirection={{ base: "column", md: "row" }} justifyContent="space-between" w="100%" >
                            <Box borderRadius={"lg"}>
                                <Flex align="center" justify={"center"} mt={2} mb={2} gap={3}>
                                    <Checkbox isChecked={isAllSelected} onChange={handleSelectAll}>
                                        <Text fontWeight={"bold"} fontSize={"12px"} >Selecionar Todos</Text>
                                    </Checkbox>
                                    <Text fontSize="sm">
                                        {selectedProducts.length} selecionado(s)
                                    </Text>
                                    <Button size="xs" colorScheme="red" onClick={clearSelection}>
                                        Limpar Seleção
                                    </Button>
                                </Flex>
                            </Box>
                            <Flex justify={"end"}>
                                <Box w={{ base: "200px", md: "200px", lg: "250px" }} bg="white" borderRadius={"lg"}>
                                    <Select w="100%" placeholder="Selecione uma ação" bg="white" borderRadius={"lg"}
                                        onChange={handleChangeAcaoMassa}
                                        value={selecaoMassa}
                                    >
                                        <option value="gerar_orcamento">Gerar Orçamento</option>
                                        <option value="gerar_lista_produtos">Gerar Lista de Produtos</option>
                                        <option value="bloquear_massa">Bloquear Selecionados</option>
                                        <option value="ativar_massa">Ativar Selecionados</option>
                                    </Select>
                                </Box>
                            </Flex>
                        </Flex>
                    </Box>
                    <Box mx={{ base: 1, md: 12, lg: 25 }} mt={2} boxShadow='md' borderRadius="lg" px={0} py={2} bg={"#FF9F59"} mb={"6"}>
                        <Text
                            fontSize="8px"
                            textAlign="center"
                            color="#F68633"
                            fontWeight="bold"
                            position="relative"
                            top="-12px"
                            ml={2}
                            bg="white"
                            w={"60px"}
                            px={1}
                            borderRadius={"lg"}
                            border="1px solid #FF9F59"
                        >
                            PRODUTOS
                        </Text>
                        {
                            buscaBool && !loading &&
                            <Alert status='warning'>
                                <AlertIcon />
                                <AlertTitle>Nenhum registro encontrado!</AlertTitle>
                            </Alert>
                        }
                        <Flex justifyContent={"center"} mt={0} mb={2}>
                            <Flex flexDirection={"column"}>
                                <Text fontSize={'10px'} fontWeight={"bold"}>
                                    Mostrando {produtos ? produtos.length : 0} de {totalRegistros} registros do {paginateFrom} ao {paginateTo}
                                </Text>
                                <Flex flexDirection={"row"}>
                                    {
                                        pagina != 1 ? (
                                            <Button
                                                onClick={() => handlePrimeira()}
                                            >
                                                {"<<"}
                                            </Button>
                                        ) :
                                            (
                                                <Button
                                                    bg="gray.300"
                                                    disabled>
                                                    {"<<"}
                                                </Button>
                                            )
                                    }
                                    {
                                        pagina > 1 ? (
                                            <Button
                                                onClick={() => handleAnterior()}
                                            >
                                                {"<"}
                                            </Button>
                                        ) :
                                            (
                                                <Button
                                                    bg="gray.300"
                                                    disabled
                                                >
                                                    {"<"}
                                                </Button>
                                            )
                                    }
                                    <Button disabled>{pagina}</Button>
                                    {

                                        pagina < ultimaPagina ? (
                                            <Button
                                                onClick={() => handleProxima()}
                                            >
                                                {">"}
                                            </Button>
                                        ) :
                                            (
                                                <Button
                                                    bg="gray.300"
                                                    disabled
                                                >
                                                    {">"}
                                                </Button>
                                            )
                                    }
                                    {
                                        pagina != ultimaPagina ? (
                                            <Button
                                                onClick={() => handleUltima()}
                                            >
                                                {">>"}
                                            </Button>
                                        ) :
                                            (
                                                <Button
                                                    bg="gray.300"
                                                    disabled
                                                >
                                                    {">>"}
                                                </Button>
                                            )
                                    }

                                </Flex>
                            </Flex>
                        </Flex>
                        <Divider borderColor="#01695E" />
                        <Box overflowX={isMobile ? "auto" : ""} >
                            <Table>
                                <Thead
                                    position="sticky"
                                    top={0}
                                    zIndex={1}
                                    backgroundColor="#FF9F59"
                                    boxShadow="md"
                                >

                                    <Tr>
                                        <Th p={1} borderColor={"none"} textAlign={"center"} fontSize={{ base: "10px" }} color="#01695E"></Th>
                                        <Th p={1} borderColor={"none"} textAlign={"center"} fontSize={{ base: "10px" }} color="#01695E">ID/SKU</Th>
                                        <Th p={1} borderColor={"none"} textAlign={"center"} fontSize={{ base: "10px" }} color="#01695E">Cod. Global</Th>
                                        <Th p={1} borderColor={"none"} textAlign={"center"} fontSize={{ base: "10px" }} color="#01695E">Nome</Th>
                                        <Th p={1} borderColor={"none"} textAlign={"center"} fontSize={{ base: "10px" }} color="#01695E">Fabricante</Th>
                                        <Th p={1} borderColor={"none"} textAlign={"center"} fontSize={{ base: "10px" }} color="#01695E">Fornecedor</Th>
                                        <Th p={1} borderColor={"none"} textAlign={"center"} fontSize={{ base: "10px" }} color="#01695E">Status</Th>
                                        <Th p={1} borderColor={"none"} textAlign={"center"} fontSize={{ base: "10px" }} color="#01695E">Estoque</Th>
                                        <Th p={1} borderColor={"none"} textAlign={"center"} fontSize={{ base: "10px" }} color="#01695E">Estoque TAGA</Th>
                                        <Th p={1} borderColor={"none"} textAlign={"center"} fontSize={{ base: "10px" }} color="#01695E">Custo</Th>
                                        <Th p={1} borderColor={"none"} textAlign={"center"} fontSize={{ base: "10px" }} color="#01695E">Preço</Th>
                                        <Th p={1} borderColor={"none"} textAlign={"center"} fontSize={{ base: "10px" }} color="#01695E">integrações</Th>
                                        <Th p={1} borderColor={"none"} textAlign={"center"} fontSize={{ base: "10px" }} color="#01695E">AÇÕES</Th>
                                    </Tr>
                                </Thead>
                                <Tbody color={"black"} bg="gray.200">
                                    {produtos && !loading && produtos.map((produto, indexProd) => {
                                        const isRowDisabled = produto.quantidade === 0 || produto.bloqueado === 1;
                                        const infoIntegracao = integracoes[produto.estoque_id];

                                        return (
                                            <Tr
                                                key={produto.produto_id}
                                                transition="background 0.2s ease-out"
                                                bg={
                                                    isChecked(produto.produto_id)
                                                        ? "#F8C162"
                                                        : indexProd % 2 === 0
                                                            ? "gray.200"
                                                            : "gray.300"
                                                }
                                                _hover={{
                                                    background: "#FFD383",
                                                    cursor: "pointer"
                                                }}
                                                // onClick={() => !isRowDisabled && handleCheckboxChange(produto.produto_id, produto)}
                                                onClick={() => handleCheckboxChange(produto.produto_id, produto)}
                                                cursor={isRowDisabled ? 'not-allowed' : 'pointer'}
                                            >
                                                {/* <Td px={1} borderColor={"white"} fontSize={{ base: "12px", sm: "12px", md: "14px", lg: "14px", xl: "16px" }} textAlign={"center"}>{<Image
                                                borderRadius="lg"
                                                src={getImagemProduto(produto)}
                                                alt={produto.fornecedor}
                                                maxW={{ base: "50px", md: "50px", lg: "50px" }}
                                                maxH="50px"
                                            />}</Td> */}
                                                <Td p={1} borderColor={"white"} fontSize={{ base: "12px", sm: "12px", md: "14px", lg: "14px", xl: "16px" }} textAlign={"center"}>
                                                    <Flex flexDirection={"row"} align={"center"} justify={"center"}>
                                                        <Tooltip text={produto.quantidade == 0 ? "O Produto está sem estoque" : produto.bloqueado == 1 ? "O Produto está bloqueado" : ""}>
                                                            <Checkbox
                                                                mr={2}
                                                                onChange={(e) => {
                                                                    e.stopPropagation();
                                                                    handleCheckboxChange(produto.produto_id, produto);
                                                                }}
                                                                isChecked={isChecked(produto.produto_id)}
                                                                // disabled={produto.quantidade == 0 || produto.bloqueado == 1 ? true : false}
                                                                iconColor="white"
                                                                _checked={{
                                                                    //bg: 'black',
                                                                    borderColor: 'black',
                                                                    _hover: {
                                                                        bg: 'gray.700',
                                                                        borderColor: 'gray.700',
                                                                    }
                                                                }}
                                                                borderColor="gray.700"
                                                            >
                                                            </Checkbox>
                                                        </Tooltip>
                                                        <ProdutoImagem
                                                            produto={produto}
                                                            origem={""}
                                                            width={"50px"}
                                                            height={"50px"}
                                                        />
                                                    </Flex>
                                                </Td>
                                                <Td p={1} borderColor={"white"} fontSize={{ base: "12px", sm: "12px", md: "14px", lg: "14px", xl: "12px" }} textAlign={"center"}>{produto.produto_id}</Td>
                                                <Td p={1} borderColor={"white"} fontSize={{ base: "12px" }} textAlign={"center"} fontWeight={"bold"}>{produto.codigo_global}</Td>
                                                <Td p={1} borderColor={"white"} fontSize={{ base: "10px" }} textAlign={"center"}>{limitarCaracteres(produto.nome, 25)}</Td>
                                                <Td p={1} borderColor={"white"} fontSize={{ base: "10px" }} textAlign={"center"} fontWeight={"bold"}>{produto.fabricante_nome}</Td>
                                                <Td p={1} borderColor={"white"} fontSize={{ base: "10px" }} textAlign={"center"}>
                                                    <Tooltip label={getFornecedor(produto)}>
                                                        <Box
                                                            mx="auto"
                                                            w="85px"
                                                            // h="30px"
                                                            h="20px"
                                                            bg="white"
                                                            p={1}
                                                            borderRadius="lg"
                                                            boxShadow="sm"
                                                            display="flex"
                                                            alignItems="center"
                                                            justifyContent="center"
                                                            borderWidth="1px" borderColor="black"
                                                        >
                                                            <Image
                                                                borderRadius="md"
                                                                src={getImagemFornecedor(produto.fornecedor_id)}
                                                                alt={getFornecedor(produto)}
                                                                objectFit="contain"
                                                                // maxW={produto.fornecedor_id == "3" ? "28px" : "75px"}
                                                                // maxH={produto.fornecedor_id == "3" ? "50px" : "75px"}
                                                                maxW={"75px"}
                                                                maxH={"18px"}
                                                            />
                                                        </Box>
                                                    </Tooltip>
                                                </Td>
                                                <Td p={1} borderColor={"white"} fontSize={{ base: "10px", sm: "10px", md: "12px", lg: "12px", xl: "12px" }} textAlign={"center"}>
                                                    {
                                                        produto.bloqueado == 1 ? (
                                                            // Caso 1: Produto permanentemente bloqueado
                                                            <Tooltip label={<DetalheBloqueio produto={produto} />} hasArrow placement="top" bg="gray.800" borderRadius="md" p={3} openDelay={200}>
                                                                <Box borderRadius="full" background={"red.300"} px={1} borderWidth="1px" borderColor="black" cursor="help">
                                                                    <Text fontWeight={"bold"}>
                                                                        BLOQUEADO
                                                                    </Text>
                                                                </Box>
                                                            </Tooltip>
                                                        ) : produto.bloqueado == 2 ? (
                                                            // Caso 2: Produto com bloqueio temporário
                                                            <Tooltip label={<DetalheBloqueio produto={produto} />} hasArrow placement="top" bg="gray.800" borderRadius="md" p={3} openDelay={200}>
                                                                <Box borderRadius="full" background={"yellow.300"} px={1} borderWidth="1px" borderColor="black" cursor="help">
                                                                    <Text fontSize={"10px"} fontWeight={"bold"}>
                                                                        BLOQUEIO TEMPORÁRIO
                                                                    </Text>
                                                                </Box>
                                                            </Tooltip>
                                                        ) : (
                                                            // Caso Padrão: Produto ativo
                                                            <Box borderRadius="full" background={"green.300"} px={1} borderWidth="1px" borderColor="black">
                                                                <Text fontWeight={"bold"}>
                                                                    ATIVO
                                                                </Text>
                                                            </Box>
                                                        )
                                                    }
                                                </Td>
                                                <Td p={1} borderColor={"white"} fontSize={{ base: "10px", sm: "10px", md: "12px", lg: "12px", xl: "12px" }} textAlign={"center"}>{produto.quantidade}</Td>
                                                <Td p={1} borderColor={"white"} fontSize={{ base: "10px", sm: "10px", md: "12px", lg: "12px", xl: "12px" }} textAlign={"center"}><Flex flexDirection={"column"} justify={"center"}>
                                                    <Box fontWeight={"bold"}>{produto.quantidade_taga}</Box>
                                                    {/* {
                                                    produto.local_localizacao && produto.local_quantidade > 0 && (
                                                        <Box color="blue">{produto.local_quantidade}({produto.local_localizacao})</Box>
                                                    )
                                                } */}
                                                    {/* {produto.locais && produto.locais.map((local) => (
                                                    <Box key={local.id}>{local.quantidade}({local.localizacao})</Box>git
                                                ))} */}
                                                </Flex>

                                                </Td>
                                                <Td p={1} borderColor={"white"} fontSize={{ base: "10px", sm: "10px", md: "12px", lg: "12px", xl: "12px" }} textAlign={"center"}>
                                                    <Flex w={"100%"} flexDirection={"row"}>
                                                        {formatarParaBRL(produto.valor_compra)}
                                                    </Flex>
                                                </Td>
                                                <Td p={1} borderColor={"white"} fontSize={{ base: "10px", sm: "10px", md: "12px", lg: "12px", xl: "12px" }} textAlign={"center"}>
                                                    <Flex w={"100%"} flexDirection={"row"}>
                                                        {formatarParaBRL(produto.valor_venda)}
                                                    </Flex>
                                                </Td>
                                                <Td p={1} borderColor={"white"} verticalAlign="middle" onClick={(e) => e.stopPropagation()}>
                                                    {/* Mostra um spinner individual por linha enquanto os dados de integração estão sendo carregados */}
                                                    {loadingIntegracoes && !infoIntegracao ? (
                                                        <Spinner size="xs" color="gray.500" />
                                                    ) : (
                                                        <Grid
                                                            templateColumns="repeat(2, 90px)"
                                                            gap={1}
                                                            w="max-content"
                                                            mx="auto"
                                                        >
                                                            {/* --- 0. E-commerce TAGA --- */}
                                                            <GridItem key="taga">
                                                                <Tooltip label={`Abrir no e-commerce TAGA: tagaautopartes.com.br/p/${produto.produto_id}`} placement="top" hasArrow>
                                                                    <Button
                                                                        w="full" h="26px" p={0}
                                                                        bg="white"
                                                                        borderRadius="md"
                                                                        overflow="hidden"
                                                                        transition="transform 0.15s ease-out"
                                                                        _hover={{ transform: 'scale(1.08)' }}
                                                                        borderWidth="1px"
                                                                        borderColor="black"
                                                                        onClick={() => abrirProdutoEcommerce(produto.produto_id)}
                                                                    >
                                                                        <Image src="/TAGANOBG.png" alt="TAGA Auto Partes" h="full" w="full" objectFit="contain" />
                                                                    </Button>
                                                                </Tooltip>
                                                            </GridItem>

                                                            {/* --- 1. Mercado Livre (Conta 1) --- */}
                                                            {infoIntegracao?.id_ml_conta_1 && (
                                                                <GridItem key="ml1">
                                                                    <Menu>
                                                                        <Tooltip label={`Mercado Livre (1): ${infoIntegracao.id_ml_conta_1}`} placement="top" hasArrow>
                                                                            <MenuButton
                                                                                as={Button}
                                                                                w="full" h="26px" p={0}
                                                                                bg="#FEE600"
                                                                                borderRadius="md"
                                                                                overflow="hidden"
                                                                                transition="transform 0.15s ease-out"
                                                                                _hover={{ transform: 'scale(1.08)' }}
                                                                                borderWidth="1px"
                                                                                borderColor="black"
                                                                            >
                                                                                <Image src="/ml_logo_2.webp" alt="Mercado Livre" h="full" w="full" objectFit="contain" />
                                                                            </MenuButton>
                                                                        </Tooltip>
                                                                        <MenuList zIndex={20}>
                                                                            <MenuItem fontSize={"14px"} icon={<FaEye size="14px" />} onClick={() => openModalML(infoIntegracao.id_ml_conta_1, 1)}>Ver Detalhes {infoIntegracao.id_ml_conta_1}</MenuItem>
                                                                            <MenuItem fontSize={"14px"} icon={<FaCopy size="14px" />} onClick={() => handleClickCopyIdAnuncioML(infoIntegracao.id_ml_conta_1)}>Copiar ID do Anúncio</MenuItem>
                                                                            <MenuItem fontSize={"14px"} icon={<FaCopy size="14px" />} onClick={() => handleClickCopyLinkML(infoIntegracao.id_ml_conta_1)}>Copiar Link do Anúncio</MenuItem>
                                                                            <MenuItem fontSize={"14px"} as={Link} href={`https://produto.mercadolivre.com.br/MLB-${infoIntegracao.id_ml_conta_1.replace("MLB", '')}`} isExternal icon={<FaExternalLinkAlt size="14px" />}>Abrir no Mercado Livre</MenuItem>
                                                                        </MenuList>
                                                                    </Menu>
                                                                </GridItem>
                                                            )}

                                                            {/* --- 2. Mercado Shops --- */}
                                                            {infoIntegracao?.link_ms && (
                                                                <GridItem key="ms">
                                                                    <Menu>
                                                                        <Tooltip label={`Mercado Shops (1): ${infoIntegracao.id_ml_conta_1}`} placement="top" hasArrow>
                                                                            <MenuButton
                                                                                as={Button} w="full" h="26px" p={0}
                                                                                bg="white" borderRadius="md" overflow="hidden"
                                                                                transition="transform 0.15s ease-out"
                                                                                _hover={{ transform: 'scale(1.08)' }}
                                                                                borderWidth="1px"
                                                                                borderColor="black"
                                                                            >
                                                                                <Image src="/ms_logo.webp" alt="Mercado Shops" h="full" w="full" objectFit="contain" />
                                                                            </MenuButton>
                                                                        </Tooltip>
                                                                        <MenuList zIndex={20}>
                                                                            <MenuItem fontSize={"14px"} icon={<FaCopy size="14px" />} onClick={() => handleClickCopyIdAnuncioML(infoIntegracao.id_ml_conta_1)}>Copiar ID do Anúncio</MenuItem>
                                                                            <MenuItem fontSize={"14px"} icon={<FaCopy size="14px" />} onClick={() => handleClickCopyLinkShops(infoIntegracao.link_ms)}>Copiar Link do Shops</MenuItem>
                                                                            <MenuItem fontSize={"14px"} as={Link} href={infoIntegracao.link_ms} isExternal icon={<FaExternalLinkAlt size="14px" />}>Abrir no Mercado Shops</MenuItem>
                                                                        </MenuList>
                                                                    </Menu>
                                                                </GridItem>
                                                            )}

                                                            {/* --- 3. Mercado Livre (Conta 2) --- */}
                                                            {infoIntegracao?.id_ml_conta_2 && (
                                                                <GridItem key="ml2">
                                                                    <Menu>
                                                                        <Tooltip label={`Mercado Livre (2): ${infoIntegracao.id_ml_conta_2}`} placement="top" hasArrow>
                                                                            <MenuButton
                                                                                as={Button} w="full" h="26px" p={0}
                                                                                bg="#FEE600" borderRadius="md" overflow="hidden"
                                                                                transition="transform 0.15s ease-out"
                                                                                _hover={{ transform: 'scale(1.08)' }}
                                                                                borderWidth="2px"
                                                                                borderColor="blue.500"
                                                                            >
                                                                                <Image src="/ml_logo_2.webp" alt="Mercado Livre" h="full" w="full" objectFit="contain" />
                                                                            </MenuButton>
                                                                        </Tooltip>
                                                                        <MenuList zIndex={20}>
                                                                            <MenuItem fontSize={"14px"} icon={<FaEye size="14px" />} onClick={() => openModalML(infoIntegracao.id_ml_conta_2, 2)}>Ver Detalhes {infoIntegracao.id_ml_conta_2}</MenuItem>
                                                                            <MenuItem fontSize={"14px"} icon={<FaCopy size="14px" />} onClick={() => handleClickCopyIdAnuncioML(infoIntegracao.id_ml_conta_2)}>Copiar ID do Anúncio</MenuItem>
                                                                            <MenuItem fontSize={"14px"} icon={<FaCopy size="14px" />} onClick={() => handleClickCopyLinkML(infoIntegracao.id_ml_conta_2)}>Copiar Link do Anúncio</MenuItem>
                                                                            <MenuItem fontSize={"14px"} as={Link} href={`https://produto.mercadolivre.com.br/MLB-${infoIntegracao.id_ml_conta_2.replace("MLB", '')}`} isExternal icon={<FaExternalLinkAlt size="14px" />}>Abrir no Mercado Livre</MenuItem>
                                                                        </MenuList>
                                                                    </Menu>
                                                                </GridItem>
                                                            )}

                                                            {/* --- 3b. Mercado Livre (Conta 3) --- */}
                                                            {infoIntegracao?.id_ml_conta_3 && (
                                                                <GridItem key="ml3">
                                                                    <Menu>
                                                                        <Tooltip label={`Mercado Livre (3): ${infoIntegracao.id_ml_conta_3}`} placement="top" hasArrow>
                                                                            <MenuButton
                                                                                as={Button} w="full" h="26px" p={0}
                                                                                bg="#FEE600" borderRadius="md" overflow="hidden"
                                                                                transition="transform 0.15s ease-out"
                                                                                _hover={{ transform: 'scale(1.08)' }}
                                                                                borderWidth="2px"
                                                                                borderColor="green.500"
                                                                            >
                                                                                <Image src="/ml_logo_2.webp" alt="Mercado Livre" h="full" w="full" objectFit="contain" />
                                                                            </MenuButton>
                                                                        </Tooltip>
                                                                        <MenuList zIndex={20}>
                                                                            <MenuItem fontSize={"14px"} icon={<FaEye size="14px" />} onClick={() => openModalML(infoIntegracao.id_ml_conta_3, 3)}>Ver Detalhes {infoIntegracao.id_ml_conta_3}</MenuItem>
                                                                            <MenuItem fontSize={"14px"} icon={<FaCopy size="14px" />} onClick={() => handleClickCopyIdAnuncioML(infoIntegracao.id_ml_conta_3)}>Copiar ID do Anúncio</MenuItem>
                                                                            <MenuItem fontSize={"14px"} icon={<FaCopy size="14px" />} onClick={() => handleClickCopyLinkML(infoIntegracao.id_ml_conta_3)}>Copiar Link do Anúncio</MenuItem>
                                                                            <MenuItem fontSize={"14px"} as={Link} href={`https://produto.mercadolivre.com.br/MLB-${infoIntegracao.id_ml_conta_3.replace("MLB", '')}`} isExternal icon={<FaExternalLinkAlt size="14px" />}>Abrir no Mercado Livre</MenuItem>
                                                                        </MenuList>
                                                                    </Menu>
                                                                </GridItem>
                                                            )}

                                                            {/* --- 4. Magalu --- */}
                                                            {false && infoIntegracao?.id_magalu && (
                                                                <GridItem key="magalu">
                                                                    <Menu>
                                                                        <Tooltip label={`Magalu: ${infoIntegracao.id_magalu}`} placement="top" hasArrow>
                                                                            <MenuButton
                                                                                as={Button} w="full" h="26px" p={0}
                                                                                bg="blue" borderRadius="md" overflow="hidden"
                                                                                transition="transform 0.15s ease-out"
                                                                                _hover={{ transform: 'scale(1.08)' }}
                                                                                borderWidth="1px"
                                                                                borderColor="black"
                                                                            >
                                                                                <Image src="/magalu-logo.webp" alt="Magalu" h="full" w="full" objectFit="contain" />
                                                                            </MenuButton>
                                                                        </Tooltip>
                                                                        <MenuList zIndex={20}>
                                                                            <MenuItem fontSize={"14px"} icon={<FaEye size="14px" />} onClick={() => openModalMagalu(infoIntegracao.id_magalu)}>Ver Detalhes</MenuItem>
                                                                            <MenuItem fontSize={"14px"} icon={<FaCopy size="14px" />} onClick={() => handleClickCopyIdAnuncioMagalu(infoIntegracao.id_magalu)}>Copiar ID</MenuItem>
                                                                        </MenuList>
                                                                    </Menu>
                                                                </GridItem>
                                                            )}

                                                            {/* --- 5. Amazon --- */}
                                                            {false && infoIntegracao?.id_amazon && (
                                                                <GridItem key="amazon">
                                                                    <Menu>
                                                                        <Tooltip label={`Amazon: ${infoIntegracao.id_amazon}`} placement="top" hasArrow>
                                                                            <MenuButton
                                                                                as={Flex}
                                                                                w="full" h="26px"
                                                                                bg="white"
                                                                                borderRadius="md"
                                                                                transition="transform 0.15s ease-out"
                                                                                _hover={{ transform: 'scale(1.08)' }}
                                                                                cursor="pointer"
                                                                                display="grid"
                                                                                placeItems="center"
                                                                                borderWidth="1px"
                                                                                borderColor="black"
                                                                            >
                                                                                <Image
                                                                                    src="/amazon-logo.webp"
                                                                                    alt="Amazon"
                                                                                    h="20px"
                                                                                    w="auto"
                                                                                    objectFit="contain"
                                                                                />
                                                                            </MenuButton>
                                                                        </Tooltip>
                                                                        <MenuList zIndex={20}>
                                                                            <MenuItem fontSize={"14px"} icon={<FaEye size="14px" />} onClick={() => openModalAmazon(infoIntegracao.id_amazon)}>Ver Detalhes</MenuItem>
                                                                            <MenuItem fontSize={"14px"} icon={<FaCopy size="14px" />} onClick={() => handleClickCopyIdAnuncioAmazon(infoIntegracao.id_amazon)}>Copiar ID</MenuItem>
                                                                        </MenuList>
                                                                    </Menu>
                                                                </GridItem>
                                                            )}
                                                        </Grid>
                                                    )}
                                                </Td>
                                                <Td p={1} borderColor={"white"} textAlign={"center"} onClick={(e) => e.stopPropagation()}>
                                                    <Flex flexDirection={"row"} mr={2}>
                                                        <Tooltip label={`Visualizar`} placement="top" hasArrow>
                                                            <Box
                                                                borderRadius={"full"}
                                                                width="35px"
                                                                height="35px"
                                                                display="flex"
                                                                alignItems="center"
                                                                justifyContent="center"
                                                                cursor={"pointer"}
                                                                onClick={() => openModal(produto)}
                                                                mr={2}
                                                                bg="white"
                                                                color="black"
                                                                borderWidth="1.5px"
                                                                borderColor="black"
                                                                transition="all 0.3s ease-in-out"
                                                                _hover={{
                                                                    bg: "#eb9659",
                                                                    borderColor: "black",
                                                                    transform: 'scale(1.2)',
                                                                }}
                                                            >
                                                                <FaEye style={{ width: '20px', height: '20px' }} />
                                                            </Box>
                                                        </Tooltip>

                                                        {
                                                            checkPermissionUser("produtos_acoes") && (
                                                                <div ref={buttonRef} id="button_acao_massa">
                                                                    <Tooltip label={`Ações`} placement="top" hasArrow>
                                                                        <Box
                                                                            borderRadius="full"
                                                                            width="35px"
                                                                            height="35px"
                                                                            display="flex"
                                                                            alignItems="center"
                                                                            justifyContent="center"
                                                                            cursor="pointer"
                                                                            onClick={() => toggleMenu(produto.produto_id)}
                                                                            bg="white"
                                                                            color="black"
                                                                            borderWidth="1.5px"
                                                                            borderColor="black"
                                                                            transition="all 0.3s ease-in-out"
                                                                            _hover={{
                                                                                bg: "#eb9659",
                                                                                borderColor: "black",
                                                                                transform: 'scale(1.2)',
                                                                            }}
                                                                        >
                                                                            <FaEllipsisV size="15px" className="acoes_button" />
                                                                        </Box>
                                                                    </Tooltip>
                                                                </div>

                                                            )

                                                        }
                                                    </Flex>

                                                    {menuVisivel == produto.produto_id && (
                                                        indexProd === produtos.length - 1 ?
                                                            (
                                                                <Box position={{ base: "relative", md: "absolute" }}>
                                                                    <Box ml={1} position={"relative"}>
                                                                        <Box
                                                                            ref={listaRef}
                                                                            position="absolute"
                                                                            top="100%"
                                                                            left="0"
                                                                            transform="translate(-200px, 10px)"
                                                                            zIndex={99999}
                                                                            bg="white"
                                                                            border="1px solid #ccc"
                                                                            borderRadius="4px"
                                                                            minWidth="300px"
                                                                            boxShadow="0 2px 4px rgba(0,0,0,0.1)"
                                                                            maxHeight="250px"
                                                                            overflowY="auto"
                                                                            mb={{ base: "60px", sm: "0", md: "0", lg: "0", xl: "0" }}
                                                                        >
                                                                            <Box as="ul" fontSize={"14px"} listStyleType="none" m={0} p={0}>
                                                                                {
                                                                                    checkPermissionUser("produtos_acao_editar") && (
                                                                                        <li disabled className='list-options' onClick={() => openModalTAGA(produto.produto_id)}>Editar Produto</li>
                                                                                    )
                                                                                }
                                                                                {
                                                                                    checkPermission() && (
                                                                                        <>
                                                                                            <li className='list-options' onClick={() => handleChangeAcaoIndiv(produto.produto_id, "bloquear_produto")}>
                                                                                                Bloquear Produto
                                                                                            </li>
                                                                                            <li className='list-options' onClick={() => handleChangeAcaoIndiv(produto.produto_id, "desbloquear_produto")}>
                                                                                                Ativar Produto
                                                                                            </li>
                                                                                            <li className='list-options' onClick={() => handleRecrearAnuncio(produto)}>Recriar Anúncio</li>
                                                                                            <li className='list-options' onClick={() => openTicketModal(produto)}>Criar Ticket de Ajuste</li>
                                                                                        </>
                                                                                    )
                                                                                }
                                                                            </Box>
                                                                        </Box>
                                                                    </Box>
                                                                </Box>
                                                            )
                                                            :
                                                            (
                                                                <Box position={{ base: "relative", md: "relative" }}>
                                                                    <Box ml={1} position={"relative"}>
                                                                        <Box
                                                                            ref={listaRef}
                                                                            position="absolute"
                                                                            top="100%"
                                                                            left="0"
                                                                            transform="translate(-200px, 10px)"
                                                                            //transform={{ base: "translate(-900px, 10px)", md: "translate(-200px, 10px)", lg: "translate(-200px, 10px)", xl: "translate(-200px, 10px)" }}
                                                                            zIndex={9999}
                                                                            bg="white"
                                                                            border="1px solid #ccc"
                                                                            borderRadius="4px"
                                                                            minWidth="300px"
                                                                            boxShadow="0 2px 4px rgba(0,0,0,0.1)"
                                                                            maxHeight="250px"
                                                                            overflowY="auto"
                                                                            mb={{ base: "50px", sm: "0", md: "0", lg: "0", xl: "0" }}
                                                                        >
                                                                            <Box as="ul" fontSize={"14px"} listStyleType="none" m={0} p={0}>
                                                                                {
                                                                                    checkPermissionUser("produtos_acao_editar") && (
                                                                                        <li className='list-options' onClick={() => openModalTAGA(produto.produto_id)}>Editar Produto</li>
                                                                                    )
                                                                                }
                                                                                {
                                                                                    checkPermission() && (
                                                                                        <>
                                                                                            <li className='list-options' onClick={() => handleChangeAcaoIndiv(produto.produto_id, "bloquear_produto")}>Bloquear Produto</li>
                                                                                            <li className='list-options' onClick={() => handleChangeAcaoIndiv(produto.produto_id, "desbloquear_produto")}>Ativar Produto</li>
                                                                                            <li className='list-options' onClick={() => handleRecrearAnuncio(produto)}>Recriar Anúncio</li>
                                                                                            <li className='list-options' onClick={() => openTicketModal(produto)}>Criar Ticket de Ajuste</li>
                                                                                        </>
                                                                                    )
                                                                                }
                                                                            </Box>
                                                                        </Box>
                                                                    </Box>
                                                                </Box>
                                                            )
                                                    )}
                                                </Td>
                                            </Tr>
                                        );
                                    })}
                                </Tbody>
                            </Table>
                        </Box>
                        <Flex justifyContent={"center"} mt={6}>
                            <Flex flexDirection={"column"}>
                                <Text fontSize={'10px'} fontWeight={"bold"}>
                                    Mostrando {produtos ? produtos.length : 0} de {totalRegistros} registros do {paginateFrom} ao {paginateTo}
                                </Text>
                                <Flex flexDirection={"row"}>
                                    {
                                        pagina != 1 ? (
                                            <Button
                                                onClick={() => handlePrimeira()}
                                            >
                                                {"<<"}
                                            </Button>
                                        ) :
                                            (
                                                <Button
                                                    bg="gray.300"
                                                    disabled>
                                                    {"<<"}
                                                </Button>
                                            )
                                    }
                                    {
                                        pagina > 1 ? (
                                            <Button
                                                onClick={() => handleAnterior()}
                                            >
                                                {"<"}
                                            </Button>
                                        ) :
                                            (
                                                <Button
                                                    bg="gray.300"
                                                    disabled
                                                >
                                                    {"<"}
                                                </Button>
                                            )
                                    }
                                    <Button disabled>{pagina}</Button>
                                    {

                                        pagina < ultimaPagina ? (
                                            <Button
                                                onClick={() => handleProxima()}
                                            >
                                                {">"}
                                            </Button>
                                        ) :
                                            (
                                                <Button
                                                    bg="gray.300"
                                                    disabled
                                                >
                                                    {">"}
                                                </Button>
                                            )
                                    }
                                    {
                                        pagina != ultimaPagina ? (
                                            <Button
                                                onClick={() => handleUltima()}
                                            >
                                                {">>"}
                                            </Button>
                                        ) :
                                            (
                                                <Button
                                                    bg="gray.300"
                                                    disabled
                                                >
                                                    {">>"}
                                                </Button>
                                            )
                                    }

                                </Flex>
                            </Flex>
                        </Flex>
                    </Box>
                </Box>
            </Box>

            <ProdutoDetalhesModal
                isOpen={isModalOpen}
                onClose={closeModal}
                produto={produtoView}
            />

            <Modal isOpen={isModalOpenML} onClose={closeModalML} size={{ base: "md", md: "xl", lg: "xl", xl: "xl" }}>
                <ModalOverlay />
                <ModalContent bg={"#FFE600"} mx={'1'}>
                    <ModalHeader color={"#01695E"} fontWeight={"bold"}>
                        <Flex flexDirection={"row"}>
                            <Box m={2} mr={{ base: "2", md: "2", lg: "4" }} w={{ base: "60px", md: "70px", lg: "75px" }}
                            >
                                <Image src="/ml_logo_2.webp" alt="Logo Mercado Livre" w={"100%"} h="25px" borderRadius="full" />
                            </Box>
                            Anúncio Mercado Livre
                        </Flex>
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {isLoadingSkeletonML ? (
                            <div className="skeleton-loader">
                                <div className="skeleton-image-block">
                                    <div className="skeleton-image"></div>
                                </div>
                                <div className="skeleton-text short"></div>
                                <div className="skeleton-text short"></div>
                                <div className="skeleton-text short"></div>
                                <div className="skeleton-text short"></div>
                                <div className="skeleton-text short"></div>
                                <div className="skeleton-image-block">
                                    <div className="skeleton-button"></div>
                                </div>
                            </div>
                        ) : (
                            <Flex direction={{ base: "column", md: "column", lg: "row" }}>
                                <Box w={{ base: "100%", md: "100%" }}>
                                    <Flex justify={"center"} align={"center"}>
                                        <Image
                                            boxShadow='lg'
                                            borderRadius="lg"
                                            src={produtoViewML.thumbnail}
                                            alt={produtoViewML.id}
                                            maxW={{ base: "90px", md: "90px", lg: "90px" }}
                                            maxH="90px"
                                            mb={4}
                                        />
                                    </Flex>
                                    <HStack mb={4}>
                                        <Text fontSize={"16px"} color="black" fontWeight="bold">
                                            ID:
                                        </Text>
                                        <Text fontSize="md" color="black">
                                            {produtoViewML.id}
                                        </Text>
                                    </HStack>
                                    <HStack mb={4}>
                                        <Text fontSize={"16px"} color="black" fontWeight="bold">
                                            CONTA:
                                        </Text>
                                        <Text fontSize="md" color="black">
                                            {
                                                contaML == 1 ?
                                                    (
                                                        contaML + " - (48.921.058/0001-02)"
                                                    )
                                                    : Number(contaML) === 3 ?
                                                    (
                                                        contaML + " - (48.921.058/0003-66)"
                                                    )
                                                    :
                                                    (
                                                        contaML + " - (48.921.058/0002-85)"
                                                    )
                                            }

                                        </Text>
                                    </HStack>
                                    <HStack>
                                        <Text fontSize={"16px"} color="black" fontWeight="bold">
                                            Título:
                                        </Text>
                                        <Text color="black" fontSize={"14px"}>
                                            {produtoViewML.title}
                                        </Text>
                                    </HStack>
                                    <HStack mt={4} flexWrap="wrap">
                                        <Text fontSize={"16px"} color="black" fontWeight="bold" mr={2.5}>
                                            {premiumML ? "Preço Clássico: R$" : "Preço: R$"}
                                        </Text>

                                        <Input
                                            fontSize="md"
                                            background={"white"}
                                            color="black"
                                            value={precoML}
                                            onChange={(e) => handlePriceChange(e, "Mercado Livre")}
                                            type='text'
                                            w="100px"
                                        />
                                        {premiumML && (
                                            <Badge colorScheme="purple" fontSize="sm" px={2} py={1} borderRadius="md">
                                                Premium no ML: R$ {Number(premiumML.preco_premium).toFixed(2).replace(".", ",")}
                                            </Badge>
                                        )}
                                    </HStack>
                                    <HStack mt={4}>
                                        <Text fontSize={"16px"} color="black" fontWeight="bold" mr={4}>
                                            Estoque:
                                        </Text>
                                        <Input
                                            type='number'
                                            fontSize="md"
                                            background={"white"}
                                            color="black"
                                            value={estoqueML}
                                            onChange={(e) => setEstoqueML(e.target.value)}
                                            w="100px"
                                        />
                                    </HStack>
                                    <HStack mt={4}>
                                        <Text fontSize={"16px"} color="black" fontWeight="bold" mr={8}>
                                            Status:
                                        </Text>
                                        <Switch
                                            isChecked={statusML === "active"}
                                            onChange={(e) => setStatusML(e.target.checked ? "active" : "paused")}
                                            colorScheme="teal"
                                            size="lg"
                                        />
                                    </HStack>
                                    <Flex justify={"center"} align={"center"} mt={4}>
                                        <Button isLoading={isLoadingBtnML} colorScheme="teal" onClick={() => atualizaAnuncioML(produtoViewML.id)}> Atualizar </Button>
                                    </Flex>
                                </Box>
                            </Flex>
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal >

            <Modal isOpen={isModalOpenMagalu} onClose={closeModalMagalu} size={{ base: "md", md: "xl", lg: "xl", xl: "xl" }}>
                <ModalOverlay />
                <ModalContent bg={"#0E89FF"} mx={'1'}>
                    <ModalHeader color={"#01695E"} fontWeight={"bold"}>
                        <Flex flexDirection={"row"}>
                            <Box m={2} mr={{ base: "2", md: "2", lg: "4" }} w={{ base: "60px", md: "70px", lg: "75px" }}
                            >
                                <Image src="/magalu-logo.webp" alt="Logo Magalu" w={"100%"} h="25px" borderRadius="full" />
                            </Box>
                            <Text color="white" >Anúncio Magalu</Text>
                        </Flex>
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {isLoadingSkeletonMagalu ? (
                            <div className="skeleton-loader">
                                <div className="skeleton-image-block">
                                    <div className="skeleton-image"></div>
                                </div>
                                <div className="skeleton-text short"></div>
                                <div className="skeleton-text short"></div>
                                <div className="skeleton-text short"></div>
                                <div className="skeleton-text short"></div>
                                <div className="skeleton-text short"></div>
                                <div className="skeleton-image-block">
                                    <div className="skeleton-button"></div>
                                </div>
                            </div>
                        ) : (
                            <Flex direction={{ base: "column", md: "column", lg: "row" }}>
                                <Box w={{ base: "100%", md: "100%" }}>
                                    <Flex justify={"center"} align={"center"}>
                                        <Image
                                            boxShadow='lg'
                                            borderRadius="lg"
                                            src={produtoViewMagalu.MainImageUrl}
                                            alt={produtoViewMagalu.IdSku}
                                            maxW={{ base: "90px", md: "90px", lg: "90px" }}
                                            maxH="90px"
                                            mb={4}
                                        />
                                    </Flex>
                                    <HStack mb={4}>
                                        <Text fontSize={"16px"} color="black" fontWeight="bold">
                                            ID:
                                        </Text>
                                        <Text fontSize="md" color="black">
                                            {produtoViewMagalu.IdSku}
                                        </Text>
                                    </HStack>
                                    <HStack>
                                        <Text fontSize={"16px"} color="black" fontWeight="bold">
                                            Título:
                                        </Text>
                                        <Text color="black" fontSize={"14px"}>
                                            {produtoViewMagalu.Name}
                                        </Text>
                                    </HStack>
                                    <HStack mt={4}>
                                        <Text fontSize={"16px"} color="black" fontWeight="bold" mr={2.5}>
                                            Preço: R$
                                        </Text>

                                        <Input
                                            fontSize="md"
                                            background={"white"}
                                            color="black"
                                            value={precoMagalu}
                                            onChange={(e) => handlePriceChange(e, "Magalu")}
                                            type='text'
                                            w="100px"
                                        />
                                    </HStack>
                                    <HStack mt={4}>
                                        <Text fontSize={"16px"} color="black" fontWeight="bold" mr={4}>
                                            Estoque:
                                        </Text>
                                        <Input
                                            type='number'
                                            fontSize="md"
                                            background={"white"}
                                            color="black"
                                            value={estoqueMagalu}
                                            onChange={(e) => setEstoqueMagalu(e.target.value)}
                                            w="100px"
                                        />
                                    </HStack>
                                    <HStack mt={4}>
                                        <Text fontSize={"16px"} color="black" fontWeight="bold" mr={8}>
                                            Status:
                                        </Text>
                                        <Switch
                                            isChecked={statusMagalu}
                                            onChange={(e) => setStatusMagalu(e.target.checked ? true : false)}
                                            colorScheme="green"
                                            size="lg"
                                        />
                                    </HStack>
                                    <Flex justify={"center"} align={"center"} mt={4}>
                                        {/* <Button isLoading={isLoadingBtnMagalu} colorScheme="teal" onClick={() => atualizaAnuncioMagalu(produtoViewMagalu.id)}> Atualizar </Button> */}
                                    </Flex>
                                </Box>
                            </Flex>
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal >


            <Modal isOpen={isModalOpenAmazon} onClose={closeModalAmazon} size={{ base: "md", md: "xl", lg: "xl", xl: "xl" }}>
                <ModalOverlay />
                <ModalContent bg={"#0E89FF"} mx={'1'}>
                    <ModalHeader color={"#01695E"} fontWeight={"bold"}>
                        <Flex flexDirection={"row"}>
                            <Box m={2} mr={{ base: "2", md: "2", lg: "4" }} w={{ base: "60px", md: "70px", lg: "75px" }}
                            >
                                <Image src="/amazon-logo.webp" alt="Logo Amazon" w={"100%"} h="25px" borderRadius="full" />
                            </Box>
                            <Text color="white" >Anúncio Amazon</Text>
                        </Flex>
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {isLoadingSkeletonAmazon ? (
                            <div className="skeleton-loader">
                                <div className="skeleton-image-block">
                                    <div className="skeleton-image"></div>
                                </div>
                                <div className="skeleton-text short"></div>
                                <div className="skeleton-text short"></div>
                                <div className="skeleton-text short"></div>
                                <div className="skeleton-text short"></div>
                                <div className="skeleton-text short"></div>
                                <div className="skeleton-image-block">
                                    <div className="skeleton-button"></div>
                                </div>
                            </div>
                        ) : (
                            <Flex direction={{ base: "column", md: "column", lg: "row" }}>
                                <Box w={{ base: "100%", md: "100%" }}>
                                    <Flex justify={"center"} align={"center"}>
                                        <Image
                                            boxShadow='lg'
                                            borderRadius="lg"
                                            src={produtoViewAmazon.MainImageUrl}
                                            alt={produtoViewAmazon.IdSku}
                                            maxW={{ base: "90px", md: "90px", lg: "90px" }}
                                            maxH="90px"
                                            mb={4}
                                        />
                                    </Flex>
                                    <HStack mb={4}>
                                        <Text fontSize={"16px"} color="black" fontWeight="bold">
                                            ID:
                                        </Text>
                                        <Text fontSize="md" color="black">
                                            {produtoViewAmazon.IdSku}
                                        </Text>
                                    </HStack>
                                    <HStack>
                                        <Text fontSize={"16px"} color="black" fontWeight="bold">
                                            Título:
                                        </Text>
                                        <Text color="black" fontSize={"14px"}>
                                            {produtoViewAmazon.Name}
                                        </Text>
                                    </HStack>
                                    <HStack mt={4}>
                                        <Text fontSize={"16px"} color="black" fontWeight="bold" mr={2.5}>
                                            Preço: R$
                                        </Text>

                                        <Input
                                            fontSize="md"
                                            background={"white"}
                                            color="black"
                                            value={precoAmazon}
                                            onChange={(e) => handlePriceChange(e, "Amazon")}
                                            type='text'
                                            w="100px"
                                        />
                                    </HStack>
                                    <HStack mt={4}>
                                        <Text fontSize={"16px"} color="black" fontWeight="bold" mr={4}>
                                            Estoque:
                                        </Text>
                                        <Input
                                            fontSize="md"
                                            background={"white"}
                                            color="black"
                                            type='number'
                                            value={estoqueAmazon}
                                            onChange={(e) => setEstoqueAmazon(e.target.value)}
                                            w="100px"
                                        />
                                    </HStack>
                                    <HStack mt={4}>
                                        <Text fontSize={"16px"} color="black" fontWeight="bold" mr={8}>
                                            Status:
                                        </Text>
                                        <Switch
                                            isChecked={statusAmazon}
                                            onChange={(e) => setStatusAmazon(e.target.checked ? true : false)}
                                            colorScheme="teal"
                                            size="lg"
                                        />
                                    </HStack>
                                    <Flex justify={"center"} align={"center"} mt={4}>
                                        {/* <Button isLoading={isLoadingBtnMagalu} colorScheme="teal" onClick={() => atualizaAnuncioMagalu(produtoViewMagalu.id)}> Atualizar </Button> */}
                                    </Flex>
                                </Box>
                            </Flex>
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal >


            <Modal isOpen={isModalOpenTAGA} onClose={closeModalTAGA} size={{ base: "md", md: "xl", lg: "xl", xl: "xl" }}>
                <ModalOverlay />
                <ModalContent bg={"gray.300"} mx={'1'}>
                    <ModalHeader color={"#01695E"} fontWeight={"bold"}>
                        <Flex flexDirection={"row"} align={"center"}>
                            <Box m={2} mr={{ base: "2", md: "2", lg: "4" }} w={{ base: "75px", md: "75px", lg: "75px" }}>
                                <Image src="/taga_logo.jpg" alt="Logo TAGA" w={"100%"} h="70px" borderRadius="full" />
                            </Box>
                            <Text color="#FF9F59">Produto TAGA</Text>
                        </Flex>
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Flex direction={{ base: "column", md: "column", lg: "row" }}>
                            <Box w={{ base: "100%", md: "100%" }}>
                                <Flex justify={"center"} align={"center"}>
                                    {/* <Image
                                        boxShadow='lg'
                                        borderRadius="lg"
                                        src={getImagemProduto(produtoViewTAGA)}
                                        alt={produtoViewTAGA.id}
                                        maxW={{ base: "90px", md: "90px", lg: "90px" }}
                                        maxH="90px"
                                        mb={4}
                                    /> */}
                                    <ProdutoImagem
                                        produto={produtoViewTAGA}
                                        origem={""}
                                        width={"150px"}
                                        height={"150px"}
                                    />
                                </Flex>
                                <HStack mb={4}>
                                    <Text fontSize={"16px"} color="black" fontWeight="bold">
                                        ID:
                                    </Text>
                                    <Text fontSize="md" color="black">
                                        {produtoViewTAGA.id}
                                    </Text>
                                </HStack>
                                <HStack>
                                    <Text fontSize={"16px"} color="black" fontWeight="bold">
                                        Título:
                                    </Text>
                                    <Text color="black" fontSize={"14px"}>
                                        {produtoViewTAGA.nome}
                                    </Text>
                                </HStack>
                                <HStack mt={4}>
                                    <Text fontSize={"16px"} color="black" fontWeight="bold" mr={2.5}>
                                        Preço: R$
                                    </Text>
                                    <Input
                                        fontSize="md"
                                        background={"white"}
                                        color="black"
                                        value={precoTAGA}
                                        onChange={(e) => handlePriceChange(e, "TAGA")}
                                        type='text'
                                        w="100px"
                                    />
                                </HStack>
                                <HStack mt={4}>
                                    <Text fontSize={"16px"} color="black" fontWeight="bold" mr={4}>
                                        Estoque:
                                    </Text>
                                    <Input
                                        fontSize="md"
                                        background={"white"}
                                        color="black"
                                        value={estoqueTAGA}
                                        type='number'
                                        onChange={(e) => setEstoqueTAGA(e.target.value)}
                                        w="100px"
                                    />
                                </HStack>

                                <Stack spacing={1} mt={4} w="100%">
                                    <Text fontSize={"16px"} color="black" fontWeight="bold">
                                        Códigos similares:
                                    </Text>
                                    <Textarea
                                        fontSize="md"
                                        background={"white"}
                                        color="black"
                                        value={codigoSimilaresTAGA}
                                        onChange={(e) => setCodigoSimilaresTAGA(e.target.value)}
                                        placeholder="Códigos separados por vírgula"
                                        rows={3}
                                    />
                                </Stack>

                                <Stack spacing={4} mt={4} w="100%">
                                    <Text fontSize={"16px"} color="black" fontWeight="bold">
                                        Estoque TAGA:
                                    </Text>
                                    <Flex flexDirection={"column"} w="full">
                                        {estoqueFisicoTAGA.length === 0 && (
                                            <Flex alignItems="center" mb={2}>
                                                <Text fontSize="md" color="black">Sem registro.</Text>
                                                <IconButton
                                                    aria-label="Adicionar item"
                                                    icon={<FaPlus />}
                                                    onClick={() => handleAddEstoqueTAGA(produtoViewTAGA.id, produtoViewTAGA.produto_estoque_id)}
                                                    colorScheme="green"
                                                    ml={2}
                                                />
                                            </Flex>
                                        )}
                                        {estoqueFisicoTAGA && estoqueFisicoTAGA.map((estoque_fisico, index) => (
                                            <Flex flexDirection={{ base: "column", md: "row" }} key={estoque_fisico.id} alignItems="center" mt={1}>
                                                <Flex flexDirection={"column"}>
                                                    <Text fontSize={"10"} fontWeight={"bold"}>QUANTIDADE</Text>
                                                    <Input
                                                        fontSize="md"
                                                        background={"white"}
                                                        color="black"
                                                        type='number'
                                                        value={estoque_fisico.quantidade}
                                                        onChange={(e) => handleChangeEstoqueTAGA(estoque_fisico.id, 'quantidade', e.target.value)}
                                                        w={{ base: "100%", md: "100px" }}
                                                        mb={{ base: 2, md: 0 }}
                                                    />
                                                </Flex>
                                                <Flex flexDirection={"column"}>
                                                    <Text fontSize={"10"} fontWeight={"bold"}>LOCALIZAÇÃO</Text>
                                                    <Input
                                                        fontSize="md"
                                                        background={"white"}
                                                        color="black"
                                                        value={estoque_fisico.localizacao}
                                                        onChange={(e) => handleChangeEstoqueTAGA(estoque_fisico.id, 'localizacao', e.target.value)}
                                                        w={{ base: "100%", md: "200px" }}
                                                        mb={{ base: 2, md: 0 }}
                                                    />
                                                </Flex>

                                                <Flex flexDirection={"row"} align={"center"} justify={"center"} mt={{ base: "0", md: "4" }}>
                                                    <Box>
                                                        <IconButton
                                                            aria-label="Remover item"
                                                            icon={<FaTrash />}
                                                            onClick={() => handleRemoveEstoqueTAGA(estoque_fisico.id)}
                                                            colorScheme="red"
                                                            ml={2}
                                                        />
                                                    </Box>
                                                    <Box>
                                                        {index === estoqueFisicoTAGA.length - 1 && (
                                                            <IconButton
                                                                aria-label="Adicionar item"
                                                                icon={<FaPlus />}
                                                                onClick={() => handleAddEstoqueTAGA(produtoViewTAGA.id, produtoViewTAGA.produto_estoque_id)}
                                                                colorScheme="green"
                                                                ml={{ base: "2", md: "2" }}
                                                                mt={{ base: "0", md: "0" }}
                                                                isDisabled={estoqueFisicoTAGA.length >= 10}
                                                            />
                                                        )}
                                                    </Box>
                                                </Flex>
                                            </Flex>
                                        ))}
                                    </Flex>
                                </Stack>
                                <Flex justify={"center"} align={"center"} mt={4}>
                                    <Button isLoading={isLoadingBtnTAGA} colorScheme="teal" onClick={() => atualizaProdutoTAGA(produtoViewTAGA.id)}> Atualizar </Button>
                                </Flex>
                            </Box>
                        </Flex>
                    </ModalBody>
                </ModalContent>
            </Modal >

            <Modal isOpen={isModalOpenOrcamento} onClose={handleCancelOrcamento} size={{ base: "md", md: "xl", lg: "4xl", xl: "5xl" }}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader><Text fontSize={"18px"}>Geração de Orçamento</Text></ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>

                            <FormControl gridColumn={{ md: "span 2" }}>
                                <FormLabel htmlFor="nomeCliente">Nome ou Razão Social</FormLabel>
                                <Input
                                    id="nomeCliente"
                                    value={nomeCliente}
                                    onChange={(e) => setNomeCliente(e.target.value)}
                                    placeholder="MINERACAO DELMIRO GOUVEIA LTDA"
                                />
                            </FormControl>

                            <FormControl>
                                <FormLabel htmlFor="documentoCliente">Documento (CPF/CNPJ)</FormLabel>
                                <Input
                                    id="documentoCliente"
                                    value={documentoCliente}
                                    onChange={(e) => setDocumentoCliente(e.target.value)}
                                    placeholder="09.154.431/0001-87"
                                />
                            </FormControl>

                            <FormControl>
                                <FormLabel htmlFor="telefoneCliente">Telefone</FormLabel>
                                <Input
                                    id="telefoneCliente"
                                    type="tel"
                                    value={telefoneCliente}
                                    onChange={handleTelefoneChange}
                                    placeholder="(99) 99999-9999"
                                />
                            </FormControl>

                            <FormControl>
                                <FormLabel htmlFor="emailCliente">Email</FormLabel>
                                <Input
                                    id="emailCliente"
                                    type="email"
                                    value={emailCliente}
                                    onChange={(e) => setEmailCliente(e.target.value)}
                                    placeholder="cliente@email.com"
                                />
                            </FormControl>

                            <FormControl>
                                <FormLabel htmlFor="valorFrete">Valor do Frete</FormLabel>
                                <InputGroup>
                                    <InputLeftAddon>R$</InputLeftAddon>
                                    <Input
                                        id="valorFrete"
                                        value={valorFrete}
                                        onChange={handleFreteChange}
                                        placeholder="0,00"
                                        textAlign="right"
                                        maxWidth={"100px"}
                                    />
                                </InputGroup>
                            </FormControl>

                            <FormControl gridColumn={{ md: "span 2" }}>
                                <FormLabel htmlFor="enderecoCliente">Endereço</FormLabel>
                                <Input
                                    id="enderecoCliente"
                                    value={enderecoCliente}
                                    onChange={(e) => setEnderecoCliente(e.target.value)}
                                    placeholder="FAZENDA ALINE, DISTRITO SAO PEDRO, SAO PEDRO, PE"
                                />
                            </FormControl>

                            <FormControl gridColumn={{ md: "span 2" }}>
                                <FormLabel htmlFor="observacoes">Observações</FormLabel>
                                <Textarea
                                    id="observacoes"
                                    value={observacoes}
                                    onChange={(e) => setObservacoes(e.target.value)}
                                    placeholder="Digite aqui observações sobre o orçamento, se necessário."
                                    rows={3}
                                />
                            </FormControl>

                            <FormControl mb={4} gridColumn={{ md: "span 2" }}>
                                <FormLabel htmlFor="vendedor">Vendedor</FormLabel>
                                <Select
                                    id="vendedor"
                                    value={vendedor}
                                    onChange={(e) => setVendedor(e.target.value)}
                                >
                                    {vendedores.map((vendedor) => (
                                        <option key={vendedor.id} value={vendedor.id}>
                                            {vendedor.name}
                                        </option>
                                    ))}
                                </Select>
                            </FormControl>

                        </SimpleGrid>
                        <Box overflowX={"auto"}>
                            <Table variant="simple">
                                <Thead>
                                    <Tr bg="gray.300">
                                        <Th textAlign={"center"}>#</Th>
                                        <Th textAlign={"center"}>ID</Th>
                                        <Th textAlign={"center"}>Imagem</Th>
                                        <Th textAlign={"center"}>Nome</Th>
                                        <Th textAlign={"center"}>Código Global</Th>
                                        <Th textAlign={"center"}>Marca</Th>
                                        <Th textAlign={"center"}>PRECO UNT. </Th>
                                        <Th textAlign={"center"}>QTD.</Th>
                                        <Th textAlign={"center"}>TOTAL</Th>
                                        <Th textAlign={"center"}>Ações</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {selectedProductDetails && selectedProductDetails.map((produto, i) => (
                                        <Tr key={produto.produto_id} bg="gray.100">
                                            <Td px={0} my={0} py={0} textAlign={"center"}>
                                                <Text fontSize={"12px"}>
                                                    {i + 1}
                                                </Text>
                                            </Td>
                                            <Td px={0} my={0} py={0} textAlign={"center"}>
                                                <Text>
                                                    {produto.produto_id}
                                                </Text>
                                            </Td>
                                            <Td m={0} py={1} textAlign={"center"}>
                                                <Flex justify={"center"} align={"center"}>
                                                    <ProdutoImagem
                                                        produto={produto}
                                                        origem={""}
                                                        width={"35px"}
                                                        height={"35px"}
                                                    />
                                                </Flex>
                                            </Td>
                                            <Td px={0} my={0} py={0} textAlign={"center"}>
                                                <Text fontSize={"12px"}>
                                                    {limitarCaracteres(produto.nome, 50)}
                                                </Text>
                                            </Td>
                                            <Td px={0} my={0} py={0} textAlign={"center"}>
                                                <Text fontSize={"12px"}>
                                                    {produto.codigo_global}
                                                </Text>
                                            </Td>
                                            <Td px={0} my={0} py={0} textAlign={"center"}>
                                                <Text fontSize={"12px"}>
                                                    {limitarCaracteres(produto.fabricante_nome, 50)}
                                                </Text>
                                            </Td>
                                            <Td px={0} my={0} py={0} textAlign={"center"}>
                                                <Text fontSize={"12px"} whiteSpace="nowrap">
                                                    R$ {formatarPreco(produto.valor_venda)}
                                                </Text>
                                            </Td>
                                            <Td px={0} my={0} py={0} textAlign={"center"}>
                                                <Input
                                                    type="number"
                                                    min="1"
                                                    max={produto.quantidade}
                                                    value={produto.quantidade_orcamento === "" ? "" : produto.quantidade_orcamento}
                                                    onChange={(e) => handleQuantidadeChange(produto.produto_id, e.target.value ? parseInt(e.target.value) : "")}
                                                    onBlur={() => handleBlur(produto.produto_id, produto.quantidade)}
                                                    width="60px"
                                                    textAlign="center"
                                                    bg="white"
                                                />
                                            </Td>
                                            <Td textAlign="center">
                                                <Text whiteSpace="nowrap">
                                                    R$ {formatarPreco((produto.valor_venda * (produto.quantidade_orcamento || 1)).toFixed(2))}
                                                </Text>
                                            </Td>
                                            <Td my={0} py={0} textAlign={"center"}>
                                                <Tooltip label={"Remover da Lista"}>
                                                    <IconButton
                                                        size={"xs"}
                                                        aria-label="Remover"
                                                        icon={<FaTrash size={10} />}
                                                        colorScheme="red"
                                                        onClick={() => removerProdutoOrcamento(produto.produto_id)}
                                                    />
                                                </Tooltip>
                                            </Td>
                                        </Tr>
                                    ))}
                                    <Tr bg="gray.200">
                                        <Td colSpan={7} textAlign="right"><Text fontWeight="bold">SUBTOTAL</Text></Td>
                                        <Td></Td>
                                        <Td textAlign="center">
                                            <Flex flexDirection={"row"} whiteSpace="nowrap">
                                                R$ {formatarPreco(subTotalOrcamento)}
                                            </Flex>
                                        </Td>
                                        <Td></Td>
                                    </Tr>
                                    <Tr bg="gray.200">
                                        <Td colSpan={7} textAlign="right"><Text fontWeight="bold">DESCONTO</Text></Td>
                                        <Td textAlign="center">
                                            <Flex flexDirection={"row"} align={"center"} justify={"center"} whiteSpace="nowrap">
                                                <Input
                                                    bg="white"
                                                    type="text"
                                                    inputMode="decimal"
                                                    value={desconto}
                                                    onChange={handleDescontoChange}
                                                    width="60px"
                                                    textAlign="center"
                                                    placeholder="0,0"
                                                />
                                                <Text ml={2}>%</Text>
                                            </Flex>
                                        </Td>
                                        <Td textAlign="center">
                                            <Flex flexDirection={"row"} whiteSpace="nowrap">
                                                <Text color="red.600">
                                                    R$ -{formatarPreco(descontoReais.toFixed(2))}
                                                </Text>
                                            </Flex>
                                        </Td>
                                        <Td></Td>
                                    </Tr>
                                    <Tr bg="gray.300">
                                        <Td colSpan={7} textAlign="right"><Text fontWeight="bold">TOTAL</Text></Td>
                                        <Td></Td>
                                        <Td textAlign="center">
                                            <Flex flexDirection={"row"} whiteSpace="nowrap">
                                                <Text fontWeight={"bold"} whiteSpace="nowrap">
                                                    R$ {formatarPreco(totalOrcamento.toFixed(2))}
                                                </Text>
                                            </Flex>
                                        </Td>
                                        <Td></Td>
                                    </Tr>

                                </Tbody>
                            </Table>
                        </Box>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            colorScheme="green"
                            mr={3}
                            onClick={handleClickGerarOrcamento}
                            isLoading={isLoadingGerarOrcamento}
                            loadingText="Processando..."
                            disabled={isLoadingGerarOrcamento}
                        >
                            {isLoadingGerarOrcamento ? (
                                <Spinner size="sm" />
                            ) : (
                                'Gerar Orçamento'
                            )}
                        </Button>
                        <Button variant="ghost" onClick={handleCancelOrcamento}>Cancelar</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <ModalListaProdutos
                produtos={selectedProductDetails}
                isOpenModalListaProdutos={isOpenModalListaProdutos}
                setIsOpenModalListaProdutos={setIsOpenModalListaProdutos}
                closeModalListaProdutos={closeModalListaProdutos}
                openModalListaProdutos={openModalListaProdutos}
                removerProdutoListaProdutos={removerProdutoListaProdutos}
            />

            <Modal isOpen={isModalConfirmarOpen} onClose={handleCloseConfirmar} isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Confirmar Ação</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text>Você tem certeza que deseja recriar os anúncios (Contas 1 e 2, e a Conta 3 se o produto já tiver anúncio nela) para o produto <Text as="b">{produtoParaRecrear?.nome}</Text>?</Text>
                        <Text mt={2} fontSize="sm" color="gray.600">Esta ação irá apagar os anúncios existentes no Mercado Livre e criar novos. Isso não pode ser desfeito.</Text>
                    </ModalBody>
                    <ModalFooter>
                        <Button variant="ghost" mr={3} onClick={handleCloseConfirmar}>
                            Cancelar
                        </Button>
                        <Button colorScheme='orange' onClick={handleConfirmarRecrear}>
                            Confirmar e Recriar
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <Modal isOpen={isModalRecrearOpen} onClose={closeModalRecrear} isCentered size="2xl">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Recriar Anúncio do Mercado Livre</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {isLoadingRecrear ? (
                            <Flex direction="column" align="center" justify="center" minH="200px">
                                <Spinner
                                    thickness='4px'
                                    speed='0.65s'
                                    emptyColor='gray.200'
                                    color='orange.500'
                                    size='xl'
                                />
                                <Text mt={4} fontSize="lg">Processando solicitação...</Text>
                                <Text fontSize="sm" color="gray.600">Criando e/ou recriando anúncios...</Text>
                            </Flex>
                        ) : (
                            <VStack spacing={4} align="stretch">
                                <Alert
                                    status='warning'
                                    variant='subtle'
                                    flexDirection='column'
                                    alignItems='center'
                                    justifyContent='center'
                                    textAlign='center'
                                    borderRadius="md"
                                >
                                    <AlertIcon boxSize='30px' mr={0} />
                                    <AlertTitle mt={2} mb={1} fontSize='md'>
                                        Atenção
                                    </AlertTitle>
                                    <AlertDescription fontSize="sm">
                                        O Anúncio pode demorar alguns minutos para ser ativado, pois o Mercado Livre realiza uma verificação na imagem.
                                    </AlertDescription>
                                </Alert>

                                {resultadoRecrear.map((res, index) => (
                                    <Box key={index} p={4} borderWidth="1px" borderRadius="md" bg={res.status === 'sucesso' ? 'green.50' : 'red.50'}>
                                        <Text fontWeight="bold" fontSize="lg" color={res.status === 'sucesso' ? 'green.600' : 'red.600'}>
                                            Conta {res.conta} - {res.status === 'sucesso' ? 'Sucesso' : 'Erro'}
                                        </Text>
                                        <Divider my={2} />
                                        <Text fontSize="sm"><strong>Mensagem:</strong> {res.mensagem}</Text>
                                        {res.id_ml_antigo && (
                                            <Text fontSize="sm"><strong>ID Antigo:</strong> {res.id_ml_antigo}</Text>
                                        )}
                                        {res.id_ml_novo && (
                                            <Text fontSize="sm"><strong>ID Novo:</strong> {res.id_ml_novo}</Text>
                                        )}

                                        {res.status === 'sucesso' && res.ml_response && (
                                            <>
                                                <Text fontSize="sm" fontWeight="bold" mt={3}>Resposta da API (ML):</Text>
                                                <Box
                                                    as="pre"
                                                    p={3}
                                                    bg="gray.100"
                                                    borderRadius="md"
                                                    maxH="200px"
                                                    overflowY="auto"
                                                    textAlign="left"
                                                    fontSize="xs"
                                                    color="gray.800"
                                                    mt={2}
                                                >
                                                    {JSON.stringify(res.ml_response, null, 2)}
                                                </Box>
                                            </>
                                        )}
                                    </Box>
                                ))}
                            </VStack>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme='gray' onClick={closeModalRecrear} isDisabled={isLoadingRecrear}>
                            Fechar
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>


            <Modal isOpen={isTicketModalOpen} onClose={closeTicketModal} isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Criar Ticket para Produto</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text mb={4}>
                            Criando ticket para: <Text as="b">{selectedProductForTicket?.nome}</Text> (ID: <Text as="b">{selectedProductForTicket?.produto_id}</Text>)
                        </Text>

                        <FormControl isRequired>
                            <FormLabel>Selecione o Problema</FormLabel>
                            <Select
                                placeholder="Escolha um template de problema"
                                value={ticketTemplate}
                                onChange={(e) => setTicketTemplate(e.target.value)}
                            >
                                <option value="Imagem incorreta">Imagem incorreta</option>
                                <option value="Titulo/Descricao incorreto">Título/Descrição incorreto</option>
                                <option value="Marca incorreta">Marca incorreta</option>
                                <option value="Unidades incorreta">Unidades incorreta</option>
                            </Select>
                        </FormControl>
                    </ModalBody>

                    <ModalFooter>
                        <Button variant="ghost" mr={3} onClick={closeTicketModal} isDisabled={isCreatingTicket}>
                            Cancelar
                        </Button>
                        <Button
                            colorScheme="orange"
                            isLoading={isCreatingTicket}
                            loadingText="Criando..."
                            onClick={handleConfirmCreateTicket}
                            disabled={!ticketTemplate || isCreatingTicket}
                        >
                            Confirmar e Criar
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <Modal isOpen={isConfirmBulkModalOpen} onClose={closeConfirmBulkModal} isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        {confirmBulkModalData.produtoId ? 'Confirmar Bloqueio' : 'Confirmar Ação em Massa'}
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text>
                            Você tem certeza que deseja
                            <Text as="span" fontWeight="bold" color={confirmBulkModalData.action === 'bloquear' ? 'red.500' : 'green.500'}>
                                {` ${confirmBulkModalData.action} `}
                            </Text>
                            <Text as="span" fontWeight="bold">
                                {confirmBulkModalData.count}
                            </Text>
                            {confirmBulkModalData.count > 1 ? ' produtos selecionados' : ' produto selecionado'}?
                        </Text>
                        {confirmBulkModalData.action === 'bloquear' && (
                            <>
                                <Text mt={2} fontSize="sm" color="gray.600">
                                    Esta ação irá pausar os anúncios vinculados nos marketplaces (Mercado Livre).
                                </Text>
                                <FormControl mt={4} isRequired>
                                    <FormLabel fontSize="sm" mb={1}>Motivo do bloqueio</FormLabel>
                                    <Select
                                        value={motivoPadrao}
                                        onChange={(e) => setMotivoPadrao(e.target.value)}
                                        placeholder="Selecione o motivo"
                                        size="sm"
                                        autoFocus
                                    >
                                        {MOTIVOS_BLOQUEIO.map((m) => (
                                            <option key={m.valor} value={m.valor}>{m.rotulo}</option>
                                        ))}
                                    </Select>
                                </FormControl>

                                {!!motivoPadrao && (
                                    <FormControl mt={3} isRequired={motivoPadrao === 'outro'}>
                                        <FormLabel fontSize="sm" mb={1}>
                                            {motivoPadrao === 'outro' ? 'Descreva o motivo' : 'Detalhe (opcional)'}
                                        </FormLabel>
                                        <Textarea
                                            value={motivoBloqueio}
                                            onChange={(e) => setMotivoBloqueio(e.target.value.slice(0, 500))}
                                            placeholder={motivoPadrao === 'outro'
                                                ? 'Ex.: peça chegou com defeito de fábrica, aguardando retorno do fornecedor'
                                                : 'Ex.: o anúncio mostra 2 presilhas e o item é só uma unidade'}
                                            size="sm"
                                            rows={2}
                                            resize="vertical"
                                        />
                                        <Text mt={1} fontSize="xs" color="gray.500">
                                            Fica no histórico do produto. {motivoBloqueio.length}/500
                                        </Text>
                                    </FormControl>
                                )}
                            </>
                        )}
                        {confirmBulkModalData.action === 'ativar' && (
                            <Text mt={2} fontSize="sm" color="gray.600">
                                Esta ação irá remover o bloqueio manual. (Obs: Anúncios pausados por falta de estoque não serão reativados).
                            </Text>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button variant="ghost" mr={3} onClick={closeConfirmBulkModal} disabled={isBulkLoading}>
                            Cancelar
                        </Button>
                        <Button
                            colorScheme={confirmBulkModalData.action === 'bloquear' ? 'red' : 'green'}
                            onClick={handleConfirmBulkAction}
                            isLoading={isBulkLoading}
                            loadingText="Processando..."
                            isDisabled={confirmBulkModalData.action === 'bloquear' && !motivoValido()}
                        >
                            Confirmar e {confirmBulkModalData.action}
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

        </>
    );
};

export default Produtos;